/* eslint-disable */
import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * @file 工具函数
 * @author zhanglili
 */
var memoize = function memoize(fn) {
  var cache = {};
  return function (n) {
    if (!cache[n]) {
      cache[n] = fn(n);
    }

    return cache[n];
  };
};
var merge = function merge(x, y) {
  if (!x) {
    return y;
  }

  if (!y) {
    return x;
  }

  return _objectSpread({}, x, y);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".lsqm-icon-svg {\n    fill: currentColor;\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n}\n";
styleInject(css);

var computeScaleStyle = memoize(function (n) {
  return {
    display: 'inline-block',
    width: "".concat(n, "em"),
    height: "".concat(n, "em")
  };
});
var createIcon = (function (type, svg) {
  var baseClassName = "lsqm-icon-svg icon-".concat(type);
  var IconComponent = svg;
  return function (_ref) {
    var className = _ref.className,
        scale = _ref.scale,
        style = _ref.style,
        props = _objectWithoutProperties(_ref, ["className", "scale", "style"]);

    var iconClassName = className ? baseClassName + ' ' + className : baseClassName;
    var scaleStyle = scale ? computeScaleStyle(scale) : null;
    var iconStyle = merge(scaleStyle, style);
    return React.createElement(IconComponent, _extends({}, props, {
      style: iconStyle,
      className: iconClassName
    }));
  };
});

var SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M289.4 511.7h446.5v63.8H289.4v-63.8zm0-318.9h63.8v191.4h-63.8V192.8z"
  }), React.createElement("path", {
    d: "M289.4 192.8h637.9v63.8H289.4v-63.8zM98 65.2h63.8v765.5H98V65.2z"
  }), React.createElement("path", {
    d: "M98 65.2h637.9V129H98V65.2z"
  }), React.createElement("path", {
    d: "M672.1 65.2h63.8v127.6h-63.8V65.2zM98 766.9h255.2v63.8H98v-63.8zm765.5-510.4h63.8v701.7h-63.8V256.5z"
  }), React.createElement("path", {
    d: "M353.2 894.4h574.1v63.8H353.2v-63.8zm-63.8-191.3h63.8v255.2h-63.8V703.1zm255.5-3.6l46.2 43.9L789 535.1 591.5 320.3l-47 43.2 157.2 170.9z"
  }));
});

/**
* @file 图标account-move
* @author zhanglili
*/
var IconAccountMove =
/*#__PURE__*/
createIcon('account-move', SVG);

var SVG$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M918 480.1H544V108.2c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v371.9H108c-5.5 0-10 4.5-10 10v44c0 5.5 4.5 10 10 10h372v374.1c0 5.5 4.5 10 10 10h44c5.5 0 10-4.5 10-10V544.1h374c5.5 0 10-4.5 10-10v-44c0-5.5-4.5-10-10-10z"
  }));
});

/**
* @file 图标add
* @author zhanglili
*/
var IconAdd =
/*#__PURE__*/
createIcon('add', SVG$1);

var SVG$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M128.239 63.868h635.543l132.761 168.067v728.288H128.239V63.868zm64.025 64.026v768.304h640.253V254.172l-99.751-126.278H192.264z"
  }), React.createElement("path", {
    d: "M256.29 63.868h448.177v192.076H256.29V63.868zm64.025 64.026v64.025h320.127v-64.025H320.315zm298.773 237.164l82.978 1.67 99.839 291.516-60.891 19.785-81.058-249.468-81.411 250.559-60.892-19.785 100.064-294.396z"
  }), React.createElement("path", {
    d: "M576.417 512.046l147.33-.396v64.025l-147.33.396zM256.29 768.147h512.203v64.025H256.29zm0-128.051h192.076v64.026H256.29z"
  }));
});

/**
* @file 图标afs
* @author zhanglili
*/
var IconAFS =
/*#__PURE__*/
createIcon('afs', SVG$2);

var SVG$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M157.545 157.764v711.26h711.26v-711.26h-711.26zM98.274 98.492h829.803v829.803H98.274V98.492z"
  }), React.createElement("path", {
    d: "M336.36 395.85c-32.735 0-59.272-26.537-59.272-59.272s26.537-59.272 59.272-59.272 59.272 26.537 59.272 59.272-26.537 59.272-59.272 59.272zm0 59.272c65.47 0 118.543-53.074 118.543-118.543S401.83 218.035 336.36 218.035s-118.543 53.074-118.543 118.543 53.074 118.544 118.543 118.544zM690.99 750.48c-32.735 0-59.272-26.537-59.272-59.272s26.537-59.272 59.272-59.272 59.272 26.537 59.272 59.272-26.537 59.272-59.272 59.272zm0 59.272c65.47 0 118.543-53.074 118.543-118.543S756.46 572.665 690.99 572.665s-118.543 53.074-118.543 118.543 53.074 118.544 118.543 118.544z"
  }), React.createElement("path", {
    d: "M751.279 277.195v177.456H453.623v118.937H216.676l.974 236.351h473.34v-59.272H276.678l-.486-117.808h236.703V513.923h297.656V217.924H344.318v59.271z"
  }));
});

/**
* @file 图标agile
* @author zhanglili
*/
var IconAGILE =
/*#__PURE__*/
createIcon('agile', SVG$3);

var SVG$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M1004.8 796.8a153.6 153.6 0 0 0-58.24-103.04 150.4 150.4 0 0 0-139.52-26.24L618.24 320a155.52 155.52 0 0 0 15.36-16 154.88 154.88 0 0 0-26.24-217.6 151.04 151.04 0 0 0-113.92-31.36A153.6 153.6 0 0 0 405.76 320l-188.8 346.88a151.04 151.04 0 0 0-64-5.12 154.88 154.88 0 0 0 18.56 308.48h18.56a152.96 152.96 0 0 0 132.48-121.6h376.96a154.88 154.88 0 0 0 150.4 122.88h18.56a154.88 154.88 0 0 0 135.04-172.16zm-304.64-13.44H323.84a152.96 152.96 0 0 0-50.56-85.12l186.88-343.68a152.96 152.96 0 0 0 51.2 8.96h18.56a156.16 156.16 0 0 0 33.28-8.32l186.88 343.68a154.88 154.88 0 0 0-49.92 84.48zM440.32 152.32a90.24 90.24 0 0 1 60.8-33.92H512a90.88 90.88 0 1 1-71.68 34.56zM244.48 871.68a90.88 90.88 0 1 1-81.92-145.92h10.24a90.88 90.88 0 0 1 71.04 146.56zm678.4 0a90.88 90.88 0 1 1-81.92-145.92h10.88a90.88 90.88 0 0 1 71.04 146.56z"
  }));
});

/**
* @file 图标alb
* @author zhanglili
*/
var IconALB =
/*#__PURE__*/
createIcon('alb', SVG$4);

var SVG$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M98.661 98.228h349.712V447.94H98.661zm476.308 0h349.712V447.94H574.969zM98.661 574.535h349.712v349.712H98.661zm476.308 0h349.712v349.712H574.969z"
  }));
});

/**
* @file 图标all-product
* @author zhanglili
*/
var IconAllProduct =
/*#__PURE__*/
createIcon('all-product', SVG$5);

var SVG$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "-447 29 1024 1024"
  }, props), React.createElement("path", {
    d: "M25.7 501.7H-372V104H25.7v397.7zm-349.7-48h301.7V152H-324v301.7zm826 48H104.3V104H502v397.7zm-349.7-48H454V152H152.3v301.7zM25.7 978H-372V580.3H25.7V978zM-324 930h301.7V628.3H-324V930zm826 48H104.3V580.3H502V978zm-349.7-48H454V628.3H152.3V930z"
  }));
});

/**
* @file 图标all-resource
* @author zhanglili
*/
var IconAllResource =
/*#__PURE__*/
createIcon('all-resource', SVG$6);

var SVG$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M453.133 75.467l42.7-32.8 49.4 37.5 12.7 8.7 13.7 8.9 11.1 6.8 12.5 7.4 13.9 7.8 15.2 8.2c2.6 1.4 5.3 2.8 8.1 4.2l17.1 8.4 18.3 8.4c3.1 1.4 6.3 2.8 9.6 4.2 44.7 18.5 91.6 30.2 139.4 34.7l18.2 1.4 71.6 1.1.1 340.6c0 53.8-15 110-44.5 167.2-28 52.6-63.3 100.3-104.9 141.7-39.1 39.8-83.1 73.8-130.8 101.1-10 5.5-21.4 10.5-33.3 14.9l-14.4 5-14.5 4.5-14.1 4-13.3 3.4-12.1 2.9-10.5 2.3-18.3 3.5-6.9-1.2-14.9-3-16.9-3.8-19.6-5c-24-6.6-50.8-15.5-71.2-26.8-45.3-25.2-90.8-60.4-131.7-101.7-91.2-92-145-199.4-149.1-296.7l-.4-12.3v-340.7l71.8-1.1c54.1-2.7 107.3-14.9 157.6-36.1 10.1-4.3 19.7-8.7 28.8-13.1l17.6-8.7 16.2-8.5 14.8-8.2 19.5-11.4 16-10 15.5-10.4 10-7.3zm51.3 54.4l-8.4-6.6-3.6 2.8c-30.1 23.4-83.5 56.3-152.8 86-51.4 21.7-105.6 35.1-162.4 39.9l-19 1.3-8.8.1v277.7c0 78.4 43 170.7 120.1 252.6l10.7 11.1c36.9 37.3 77.6 68.7 117.3 90.8 19 10.5 51.1 20.5 84.7 27.9l13.8 2.9 1-.2c6.4-1.3 13.1-2.8 20-4.4l10.5-2.6c28.4-7.3 52.7-15.8 67.2-23.8 42.6-24.3 81.9-54.7 117.4-90.8 37-36.8 68.5-79.4 93.2-125.7 22.8-44 35-86.3 37-125.9l.3-11.8-.2-277.6-11.5-.2c-61.1-3.5-121.2-17.3-178.9-41.2-7.3-3.1-14.5-6.4-21.7-9.7l-21.2-10.2-20.4-10.5c-3.3-1.8-6.6-3.5-9.8-5.3l-18.6-10.6-17.1-10.1-15.2-9.5c-2.4-1.5-4.6-3-6.8-4.5l-11.9-8.2c-1.7-1.3-3.4-2.5-4.9-3.7z"
  }), React.createElement("path", {
    d: "M358.133 508.667l78.8-238.9 72.9 255.7 47.4-124.9 65.2 108.1h62.3v64h-98.4l-15.9-26.4-69.1 182.4-68.9-241.2-28 85.2h-110.8v-64z"
  }));
});

/**
* @file 图标antispam
* @author zhanglili
*/
var IconAntispam =
/*#__PURE__*/
createIcon('antispam', SVG$7);

var SVG$8 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    stroke: "#666",
    d: "M6.862 8.978v5h-5v-5h5zm7 0v5h-5v-5h5zm-2.5-7.622l2.828 2.829-2.828 2.828-2.829-2.828 2.829-2.829zm-4.5.622v5h-5v-5h5z"
  })));
});

/**
* @file 图标application
* @author zhanglili
*/
var IconApplication =
/*#__PURE__*/
createIcon('application', SVG$8);

var SVG$9 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M9.194 10.825v7.28h-7.28v-7.28h7.28zm8.418 0v7.28h-7.28v-7.28h7.28zM13.965 1.92l4.118 4.119-4.118 4.118L9.846 6.04l4.119-4.119zm-4.77.486v7.28h-7.28v-7.28h7.28z"
  }));
});

/**
* @file 图标application-solid
* @author zhanglili
*/
var IconApplicationSolid =
/*#__PURE__*/
createIcon('application-solid', SVG$9);

var SVG$a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "12",
    height: "12"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M12 6A6 6 0 0 1 0 6a6 6 0 0 1 12 0"
  }), React.createElement("path", {
    d: "M5 6h4v1H5z"
  }), React.createElement("path", {
    d: "M6 2v5H5V2z"
  })));
});

/**
* @file 图标arrow
* @author zhanglili
*/
var IconArrow =
/*#__PURE__*/
createIcon('arrow', SVG$a);

var SVG$b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 12"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("g", {
    "data-name": "\u4E0B\u62C9\u83DC\u5355 \u586B\u5145"
  }, React.createElement("path", {
    d: "M0 0h12v12H0z",
    fill: "none"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 4L6 8 2 4z"
  })))));
});

/**
* @file 图标arrows-down
* @author zhanglili
*/
var IconArrowsDown =
/*#__PURE__*/
createIcon('arrows-down', SVG$b);

var SVG$c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    fill: "#333",
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M1 11h1v3h3v1H1zm14 0v4h-4v-1h3v-3zM5 1v1H2v3H1V1zm10 0v4h-1V2h-3V1z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 7v1a2.49 2.49 0 0 0 2.34 2.49H9a2.49 2.49 0 0 0 2.49-2.34V7h1v1a3.49 3.49 0 0 1-3.31 3.49H8.5v3h-1v-3H7a3.49 3.49 0 0 1-3.49-3.3V7zM8 1.5A2.5 2.5 0 0 1 10.5 4v3a2.5 2.5 0 0 1-5 0V4A2.5 2.5 0 0 1 8 1.5zm0 1A1.5 1.5 0 0 0 6.5 4v3a1.5 1.5 0 0 0 3 0V4A1.5 1.5 0 0 0 8 2.5z",
    "data-name": "\u5F62\u72B6\u7ED3\u5408"
  }))));
});

/**
* @file 图标asr
* @author zhanglili
*/
var IconAsr =
/*#__PURE__*/
createIcon('asr', SVG$c);

var SVG$d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.7 954.2L129.3 733.5V291.9L511.7 71.2 894.1 292v441.5L511.7 954.2zM192.4 697l319.3 184.4L831 697V328.3L511.7 144 192.4 328.3V697z"
  }), React.createElement("path", {
    d: "M480.5 670H354.8c-69.6 0-126.3-56.7-126.3-126.3s56.7-126.3 126.3-126.3h62.6V291h63.1v379zM354.8 480.5c-34.9 0-63.2 28.4-63.2 63.2 0 34.9 28.4 63.3 63.2 63.3h62.6V480.5h-62.6zm440.5 189.3H669.4c-69.5 0-126.1-56.6-126.1-126.1V416.9h63.1v126.8c0 34.8 28.3 63.1 63.1 63.1h62.8V416.9h63.1v252.9z"
  }));
});

/**
* @file 图标baidu-app-svsp
* @author zhanglili
*/
var IconBaiduAppSVSP =
/*#__PURE__*/
createIcon('baidu-app-svsp', SVG$d);

var SVG$e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2.35a6.06 6.06 0 0 1 5.69 4.15l.05.18.17.13a6.14 6.14 0 0 1 2.23 4.48v.26a6.06 6.06 0 0 1-6 6.1 5.76 5.76 0 0 1-1.89-.31l-.25-.09-.25.09a6 6 0 0 1-1.57.3h-.32a6.06 6.06 0 0 1-6-6.1 6 6 0 0 1 2.38-4.81A6 6 0 0 1 10 2.35zM16 9v.11a6.24 6.24 0 0 1-2.21 4.11l-.24.19h-.53L10 12.86l-2.21.5v.06A4.81 4.81 0 0 0 10 15.71l.24.11a4.32 4.32 0 0 0 1.58.39h.48a4.63 4.63 0 0 0 4.38-4.44v-.22A4.66 4.66 0 0 0 16 9.09zM7.86 6.89a4.51 4.51 0 0 0-2.72.9 4.7 4.7 0 0 0-1.87 3.52v.46a4.64 4.64 0 0 0 4.59 4.45h.36l-.16-.14a5.91 5.91 0 0 1-1.78-2.8L6.21 13v-.47L9 7h-.09a3.51 3.51 0 0 0-.79-.12zM10 8.22L8.21 11.8l1.08-.24v-1a.7.7 0 0 1 .61-.7h.2a.7.7 0 0 1 .6.6v1.09l1.08.24zm0-4.44h-.23a4.56 4.56 0 0 0-3.43 1.85h.23a5.49 5.49 0 0 1 1-.14h.33a5.81 5.81 0 0 1 2.14.4l.31.13h.07l.08.06.06.06.05.07.06.09 2.68 5.37a4.8 4.8 0 0 0 1.24-3v-.64a4.65 4.65 0 0 0-4.37-4.24z"
  }))));
});

/**
* @file 图标baidu-cloud
* @author zhanglili
*/
var IconBaiduCloud =
/*#__PURE__*/
createIcon('baidu-cloud', SVG$e);

var SVG$f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M11.661 4.892l-7.296 7.317"
  }), React.createElement("path", {
    d: "M2 1h12v14H2V1zm1 1v12h10V2H3z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5h5v1H4zm3 6h5v1H7z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3h1v5H6z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标batch
* @author zhanglili
*/
var IconBatch =
/*#__PURE__*/
createIcon('batch', SVG$f);

var SVG$g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M573.951 98.228h353.185V927H573.951V98.228zm59.198 769.574h234.789V157.426H633.149v710.376zM98.364 98.228H512.75V927H98.364V98.228zm59.198 59.198v710.376h295.99V157.426h-295.99z"
  }), React.createElement("path", {
    d: "M218.763 276.714h176.591v174.863H218.763V276.714zm59.198 115.666h58.195v-56.467h-58.195v56.467zm412.383-116.558h59.198v177.594h-59.198zm59.198 118.396h59.198V631.01h-59.198zm-59.198 177.594h59.198v177.594h-59.198zm-471.581 0h176.591v174.863H218.763V571.812zm59.198 115.665h58.195V631.01h-58.195v56.467z"
  }));
});

/**
* @file 图标bcloud
* @author zhanglili
*/
var IconBCloud =
/*#__PURE__*/
createIcon('bcloud', SVG$g);

var SVG$h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "-56 749 1024 1024"
  }, props), React.createElement("path", {
    d: "M870.6 1251.4l1.5-140.9-421-297-412.6 295.8 417.6 298.4 355.3-253.8v62.2l-358.2 264.5-412-295.6v224.1l418.2 298.6 228.2-151.8 124.6-.2-.1-59.2-142.4.2-209.2 139.1-360.1-257.6-.1-76.8 352.6 251.8 417.7-301.8zm-414.5 83.4l-315.8-225.6 311-223 318.4 224.5-313.6 224.1z"
  }), React.createElement("path", {
    d: "M340.8 1012.4L226.2 1096l252.6 175.6 56.7-41.4-98.3-68.3 32.9-24 153.6 22.1 79.9-49.4-177.9-18.2c33.2-36.1 28.5-68.5-14.2-97.1-51-32.2-107.9-26.5-170.7 17.1zm102.8 84.5l-48.8 35.6-67.4-46.9 48.8-35.6c30.3-23.1 56.5-26 78.5-8.4 22.8 14.8 19.1 33.2-11.1 55.3z"
  }));
});

/**
* @file 图标bdrp
* @author zhanglili
*/
var IconBDRP =
/*#__PURE__*/
createIcon('bdrp', SVG$h);

var SVG$i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M128.265 65.381h767.007v894.842H128.265V65.381zm63.918 63.917v767.007h639.173V129.298H192.183z"
  }), React.createElement("path", {
    d: "M256.1 384.968h191.752v383.504H256.1V384.968zm63.917 63.917v255.669h63.917V448.885h-63.917zm255.669-255.669h191.752V576.72H575.686V193.216zm63.918 63.917v255.669h63.917V257.133h-63.917zM383.935 384.968v-255.67h-63.918v255.67z"
  }), React.createElement("path", {
    d: "M383.935 896.11V736.513h-63.918V896.11zm319.586-702.894v-63.918h-63.917v63.918zm0 447.421v-63.918h-63.917v63.918zm-127.835 0h319.586v191.752H575.686V640.637zm63.918 63.917v63.917h191.752v-63.917H639.604z"
  }));
});

/**
* @file 图标bgw
* @author zhanglili
*/
var IconBGW =
/*#__PURE__*/
createIcon('bgw', SVG$i);

var SVG$j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M98.319 127.784v800.51h355.054v-237.08h-59.265v177.815H157.584V157.417h236.524v72.104h59.265V98.152H97.782v59.265m829.175-29.625v800.51H571.903V810.258h59.265v58.779h236.524V157.424H631.168l-.351 118.221h-59.265l.351-177.486h355.591"
  }), React.createElement("path", {
    d: "M494.689 299.86l-35.02-47.811-274.697 201.2h623.992v-59.265H366.183zm163.837 331.685l-129.508 94.128 34.843 47.941 277.01-201.334H216.313v59.265z"
  }));
});

/**
* @file 图标bigpipe
* @author zhanglili
*/
var IconBigpipe =
/*#__PURE__*/
createIcon('bigpipe', SVG$j);

var SVG$k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M130.191 63.854h765.786v893.417H130.191V63.854zm63.815 63.816v765.786h638.155V127.67H194.006z"
  }), React.createElement("path", {
    d: "M513.084 191.485h63.815v319.078h-63.815V191.485zm31.908 31.908l31.908 31.908h-63.815l31.907-31.908z"
  }), React.createElement("path", {
    d: "M576.899 191.485h95.723c52.867 0 95.723 42.857 95.723 95.723s-42.857 95.723-95.723 95.723h-95.723c-35.244 0-63.815-28.571-63.815-63.816v-63.816c0-35.243 28.571-63.814 63.815-63.814zm0 63.816v63.816h95.723c17.622 0 31.908-14.286 31.908-31.908s-14.286-31.908-31.908-31.908h-95.723z"
  }), React.createElement("path", {
    d: "M576.899 319.116h95.723c52.867 0 95.723 42.857 95.723 95.723 0 52.867-42.857 95.723-95.723 95.723h-95.723c-35.244 0-63.815-28.571-63.815-63.816V382.93c0-35.243 28.571-63.814 63.815-63.814zm0 63.816v63.816h95.723c17.622 0 31.908-14.286 31.908-31.908s-14.286-31.908-31.908-31.908h-95.723zM190.793 638.194h194.66v-63.816h-194.66z"
  }), React.createElement("path", {
    d: "M256.215 510.563v191.446h63.816V510.563zm240.346 39.695L201.812 805.52l41.778 48.24 294.748-255.262zM385.453 765.825h191.446v63.815H385.453z"
  }));
});

/**
* @file 图标big-sql
* @author zhanglili
*/
var IconBigSQL =
/*#__PURE__*/
createIcon('big-sql', SVG$k);

var SVG$l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M648.197 509.74c0-76.799-62.258-139.057-139.057-139.057S370.084 432.941 370.084 509.74c0 45.978 22.51 88.213 59.478 114.047l31.861-45.593c-22.232-15.536-35.717-40.837-35.717-68.454 0-46.079 37.355-83.434 83.434-83.434s83.434 37.355 83.434 83.434-37.355 83.434-83.434 83.434h-14.67l-59.855 87.493 45.908 31.406 43.853-64.102c69.631-7.587 123.821-66.581 123.821-138.231zM219.184 173.22l36.313 42.133c-85.329 73.542-135.302 180.215-135.302 295.061 0 114.914 50.033 221.644 135.449 295.188l-36.292 42.151c-97.562-84.001-154.78-206.057-154.78-337.339.001-131.204 57.15-253.195 154.612-337.194zm580.259 676.229l-36.346-42.105c85.191-73.54 135.069-180.122 135.069-294.86 0-116.666-51.582-224.861-139.255-298.422l35.752-42.611c100.139 84.02 159.126 207.749 159.126 341.034 0 131.08-57.041 252.968-154.346 336.964z"
  }), React.createElement("path", {
    d: "M675.023 745.624l-36.883-41.636c59.251-52.487 93.782-127.551 93.782-208.257 0-62.459-20.613-121.706-58.027-170.051l43.988-34.043c44.891 58.006 69.662 129.203 69.662 204.094 0 96.796-41.475 186.957-112.522 249.893zM289.995 305.125l45.714 31.687c-31.977 46.132-49.366 100.844-49.366 158.23 0 81.307 35.051 156.877 95.071 209.391l-36.627 41.861C272.82 683.327 230.72 592.56 230.72 495.041c.001-68.801 20.897-134.549 59.275-189.916z"
  }));
});

/**
* @file 图标bns
* @author zhanglili
*/
var IconBNS =
/*#__PURE__*/
createIcon('bns', SVG$l);

var SVG$m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M5.94 2l3.14 2H15v11H1V2zm-.29 1H2v11h12V5H8.78zm1.82 2.79V13h-1V7.46L5.34 8.69 4.6 8l2-2.23zm2 0v5.49l1.13-1.23.74.67L9.3 13h-.83V5.79z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标bpfs
* @author zhanglili
*/
var IconBPFS =
/*#__PURE__*/
createIcon('bpfs', SVG$m);

var SVG$n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M10 1v1.88a4.84 4.84 0 0 1 1.14.62l.28.21.76-.44.86-.5.49.86 1 1.74.5.86-.85.5-.77.44a4.57 4.57 0 0 1 .07.83h-1a2.68 2.68 0 0 0 0-.4v-.27l-.12-.68 1.36-.78-1-1.73-1.35.78-.55-.45a4.31 4.31 0 0 0-.89-.56l-.24-.1L9 3.56V2H7v1.56l-.66.26a4.55 4.55 0 0 0-.92.5l-.21.16-.53.44-1.33-.78-1 1.73 1.36.78-.12.7a3.7 3.7 0 0 0 0 1.05v.27l.12.68-1.36.78 1 1.73 1.35-.78.55.45a4.31 4.31 0 0 0 .89.56l.24.1.64.25V14H8v1H6v-1.88a4.84 4.84 0 0 1-1.14-.62l-.28-.21-.76.44-.86.5-.49-.86-1-1.74L1 9.77l.85-.5.77-.44a5 5 0 0 1 0-1.63l-.77-.44L1 6.23l.5-.86 1-1.74.5-.86.86.5.76.44A4.78 4.78 0 0 1 5.69 3L6 2.88V1zm5 12v1H9v-1zm0-2v1H9v-1zM8 5.5A2.5 2.5 0 0 1 10.5 8h-1A1.5 1.5 0 1 0 8 9.5v1a2.5 2.5 0 0 1 0-5zM15 9v1H9V9z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标brcc
* @author zhanglili
*/
var IconBrcc =
/*#__PURE__*/
createIcon('brcc', SVG$n);

var SVG$o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M360.658 100.16L484.99 227.75H927v699.41H97v-827h263.658zm-26.997 64H161v699h702V291.75H457.995L333.661 164.16zm294.05 291.62c56.302 56.302 63.11 143.357 20.421 207.096l75.038 75.04-45.255 45.254-75.039-75.038c-63.739 42.688-150.794 35.881-207.096-20.421-64.046-64.046-64.046-167.885 0-231.931 64.046-64.046 167.885-64.046 231.93 0zm-186.677 45.254c-39.052 39.053-39.052 102.37 0 141.422 39.053 39.052 102.37 39.052 141.422 0 39.052-39.053 39.052-102.37 0-141.422-39.053-39.052-102.37-39.052-141.422 0z"
  }));
});

/**
* @file 图标brcc-project
* @author zhanglili
*/
var IconBrccProject =
/*#__PURE__*/
createIcon('brcc-project', SVG$o);

var SVG$p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M192.166 128.16v640.049h512.039V128.16H192.166zm-64.005-64.005H768.21v768.058H128.161V64.155z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M256.17 256.17h64.005v64.005H256.17zm0 128.009h64.005v64.005H256.17zm0 128.01h64.005v64.005H256.17z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    d: "M384.18 256.17h256.019v64.005H384.18zm0 128.009h256.019v64.005H384.18zm0 128.01h256.019v64.005H384.18zM832.214 256.17h64.005v704.054h-64.005z"
  }), React.createElement("path", {
    d: "M384.18 896.218h512.039v64.005H384.18z"
  }));
});

/**
* @file 图标bugbye
* @author zhanglili
*/
var IconBugbye =
/*#__PURE__*/
createIcon('bugbye', SVG$p);

var SVG$q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M192.396 127.904v767.818h639.848V127.904H192.396zm-63.984-63.985H896.23v895.787H128.412V63.919z"
  }), React.createElement("path", {
    d: "M448.336 319.859v63.985h383.909v-63.985H448.336zm-63.985-63.985h511.878v191.954H384.351V255.874zm63.985 319.924v63.985h383.909v-63.985H448.336zm-63.985-63.985h511.878v191.954H384.351V511.813z"
  }));
});

/**
* @file 图标build-cloud
* @author zhanglili
*/
var IconBuildCloud =
/*#__PURE__*/
createIcon('build-cloud', SVG$q);

var SVG$r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M15 1v14H1V1zM8 12a3 3 0 0 1-2.83-2H2v4h12v-4h-3.17A3 3 0 0 1 8 12zM6 9a2 2 0 0 0 4 0h4V2H2v7zm6-3v1H4V6zm0-2v1H4V4z"
  }))));
});

/**
* @file 图标ccos
* @author zhanglili
*/
var IconCCOS =
/*#__PURE__*/
createIcon('ccos', SVG$r);

var SVG$s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "16",
    height: "16",
    fill: "currentColor"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M6 10.5V14H2.5v-3.5H6zm8 0V14h-3.5v-3.5H14zm-8-8V6H2.5V2.5H6zm8 0V6h-3.5V2.5H14z"
  }), React.createElement("path", {
    stroke: "currentColor",
    d: "M6 5.661v6.589m4.5-7.189v6.693M5.605 6h5.794m-5.794 4.5h6.153"
  })));
});

/**
* @file 图标cdn
* @author zhanglili
*/
var IconCDN =
/*#__PURE__*/
createIcon('cdn', SVG$s);

var SVG$t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M10.5 7.5a2.5 2.5 0 1 0-3.931 2.05l.573-.82A1.5 1.5 0 1 1 8 9h-.264L6.66 10.573l.825.565.788-1.152A2.502 2.502 0 0 0 10.5 7.5z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 5V1h-4v1.5H5V1H1v4h1.5v6H1v4h4v-1.5h6V15h4v-4h-1.5V5H15zm-3-1h2V2h-2v2zM2 4h2V2H2v2zm0 10h2v-2H2v2zm10 0h2v-2h-2v2zm.5-3H11v1.5H5V11H3.5V5H5V3.5h6V5h1.5v6z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标chaosengineer
* @author zhanglili
*/
var IconChaosengineer =
/*#__PURE__*/
createIcon('chaosengineer', SVG$t);

var SVG$u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(-522 -467)"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M536.25 469.969h-1.092a.498.498 0 0 0-.392.19l-6.443 8.161-3.089-3.914a.5.5 0 0 0-.392-.19h-1.092a.125.125 0 0 0-.098.201l4.28 5.422a.5.5 0 0 0 .785 0l7.631-9.67a.124.124 0 0 0-.098-.2z"
  })));
});

/**
* @file 图标check
* @author zhanglili
*/
var IconCheck =
/*#__PURE__*/
createIcon('check', SVG$u);

var SVG$v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M775.8 203.5L511.3 467.9 248.3 205c-3.9-3.9-10.2-3.9-14.1 0l-31.1 31c-3.9 3.9-3.9 10.2 0 14.1l262.9 263-263 263c-3.9 3.9-3.9 10.2 0 14.1l31.2 31.2c3.9 3.9 10.2 3.9 14.1 0l263-263L775.8 823c3.9 3.9 10.2 3.9 14.1 0l31.2-31.2c3.9-3.9 3.9-10.2 0-14.1L556.6 513.2 821 248.7c3.9-3.9 3.9-10.2 0-14.1l-31-31.1c-3.9-3.9-10.3-3.9-14.2 0z"
  }));
});

/**
* @file 图标close
* @author zhanglili
*/
var IconClose =
/*#__PURE__*/
createIcon('close', SVG$v);

var SVG$w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M10 2.93a6.567 6.567 0 0 1 6.52 5.827 3.833 3.833 0 0 1 2.23 3.483 3.832 3.832 0 0 1-3.618 3.829l-.21.005H4.968A3.834 3.834 0 0 1 1.25 12.24c0-1.545.913-2.878 2.23-3.484A6.567 6.567 0 0 1 10 2.93zm0 1.25a5.317 5.317 0 0 0-5.248 4.488l-.03.228-.08.7-.64.295a2.584 2.584 0 0 0-1.502 2.35c0 1.343 1.025 2.451 2.307 2.573l.161.01h9.92l.176-.004a2.582 2.582 0 0 0 2.436-2.58c0-.956-.522-1.816-1.336-2.264l-.166-.084-.64-.295-.08-.7A5.317 5.317 0 0 0 10 4.18zm3.926 3.98a2.041 2.041 0 0 1-3.163 2.446l-1.987.969a2.042 2.042 0 1 1-.44-1.177l1.77-.864a2.042 2.042 0 0 1 3.82-1.373zM6.39 10.957a.791.791 0 1 0 .694 1.422.791.791 0 0 0-.694-1.422zm5.354-2.611a.791.791 0 1 0 .694 1.422.791.791 0 0 0-.694-1.422z"
  }));
});

/**
* @file 图标cloud-native
* @author zhanglili
*/
var IconCloudNative =
/*#__PURE__*/
createIcon('cloud-native', SVG$w);

var SVG$x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M2.402 6.874l6.835 3.586v7.868l-6.835-3.781V6.874zm15.195.082v7.552l-6.836 3.816v-7.859l6.836-3.509zM4.355 9.621v1.524l2.286 1.198v-1.524L4.355 9.621zM10 1.25l7.331 4.131-7.328 3.761-7.306-3.834L10 1.25z"
  }));
});

/**
* @file 图标cloud-product
* @author zhanglili
*/
var IconCloudProduct =
/*#__PURE__*/
createIcon('cloud-product', SVG$x);

var SVG$y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M218.81 499.65V668l197.41 114a111.49 111.49 0 1 1-15.09 81.36L140.81 713V499.65zM510.5 808a33.5 33.5 0 1 0 33.5 33.5 33.5 33.5 0 0 0-33.5-33.5zm333-615a111.52 111.52 0 0 1 38.69 216.11V713l-169 97.55-39-67.55 130-75V408.87A111.52 111.52 0 0 1 843.5 193zm-333 112l168 96.75v193.5L510.5 692l-168-96.75v-193.5zm0 90l-90 51.83v103.33l90 51.83 90-51.83V446.84zm1-324l162.94 94-39 67.55L511.48 161 289.89 288.69A112.94 112.94 0 0 1 291 304.5a111.48 111.48 0 1 1-38.5-84.29zm-332 200a33.5 33.5 0 1 0 33.5 33.5 33.5 33.5 0 0 0-33.5-33.5zm664 0a33.5 33.5 0 1 0 33.5 33.5 33.5 33.5 0 0 0-33.5-33.5z",
    "data-name": "\u4FA7\u56FE\u6807/\u540D\u79F0/APPSpace"
  }))));
});

/**
* @file 图标cnap
* @author zhanglili
*/
var IconCNAP =
/*#__PURE__*/
createIcon('cnap', SVG$y);

var SVG$z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M10.05 2a.17.17 0 0 1 .17.13l2.54 5.2L18.4 8a.18.18 0 0 1 .1.33L14.11 12l1.27 5.76a.17.17 0 0 1-.06.2.2.2 0 0 1-.22 0l-5-2.95L5 18a.2.2 0 0 1-.22 0 .19.19 0 0 1-.07-.2L6 12 1.59 8.3a.19.19 0 0 1-.07-.2.18.18 0 0 1 .13-.1l5.69-.65 2.53-5.2a.19.19 0 0 1 .18-.15zm1.72 6.73L10.05 5.2 8.33 8.73l-3.43.39 2.75 2.32-.82 3.72 3.22-1.88 3.22 1.88-.82-3.72 2.74-2.32z"
  }))));
});

/**
* @file 图标collect
* @author zhanglili
*/
var IconCollect =
/*#__PURE__*/
createIcon('collect', SVG$z);

var SVG$A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M10.05 2a.17.17 0 0 1 .17.13l2.54 5.2L18.4 8a.18.18 0 0 1 .1.33L14.11 12l1.27 5.76a.17.17 0 0 1-.06.2.2.2 0 0 1-.22 0l-5-2.95L5 18a.2.2 0 0 1-.22 0 .19.19 0 0 1-.07-.2L6 12 1.59 8.3a.19.19 0 0 1-.07-.2.18.18 0 0 1 .13-.1l5.69-.65 2.53-5.2a.19.19 0 0 1 .18-.15z"
  }))));
});

/**
* @file 图标collected
* @author zhanglili
*/
var IconCollected =
/*#__PURE__*/
createIcon('collected', SVG$A);

var SVG$B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512 65l392 223.5v447L512 959 120 735.5v-447L512 65zm0 73.672L184 325.681v372.637l328 187.009 328-187.01V325.682l-328-187.01zM512 358c85.052 0 154 68.948 154 154s-68.948 154-154 154-154-68.948-154-154 68.948-154 154-154zm0 64c-49.706 0-90 40.294-90 90s40.294 90 90 90 90-40.294 90-90-40.294-90-90-90z"
  }));
});

/**
* @file 图标config
* @author zhanglili
*/
var IconConfig =
/*#__PURE__*/
createIcon('config', SVG$B);

var SVG$C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M271.547 789.451H98.797V98.453h690.999v172.749h-69.1V167.553H167.897v552.798h103.65z"
  }), React.createElement("g", {
    mask: "url(#b)",
    transform: "translate(2 2)"
  }, React.createElement("path", {
    d: "M925.996 925.651H234.997V234.652h690.999v690.999zm-621.899-69.1h552.799V303.752H304.097v552.799z"
  })));
});

/**
* @file 图标copy
* @author zhanglili
*/
var IconCopy =
/*#__PURE__*/
createIcon('copy', SVG$C);

var SVG$D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M8 1l3 1.75v3.5l-1.1.65L11 8.57 12 8l3 1.75v3.5L12 15l-3-1.76v-.75H7v.75L4 15l-3-1.76v-3.5L4 8l1 .52 1-1.67-1-.6v-3.5zM4 9.15l-2 1.16v2.35l2 1.17 2-1.17v-2.35zm8 0l-2 1.16v2.35l2 1.17 2-1.17v-2.35zM4 10l1.28.71v1.43L4 12.86l-1.29-.72v-1.43zm8 0l1.28.71v1.43l-1.28.72-1.29-.72v-1.43zM6.87 7.35L5.82 9 7 9.74v1.75h2V9.74l1.13-.66L9 7.4 8 8zM8 2.15L6 3.33v2.34l2 1.17 2-1.17V3.33zM8 3l1.28.71v1.43L8 5.86l-1.27-.72V3.71z"
  }))));
});

/**
* @file 图标cos
* @author zhanglili
*/
var IconCOS =
/*#__PURE__*/
createIcon('cos', SVG$D);

var SVG$E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 17"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M16.17 11.92L18 13.26 9 17l-9-3.74 1.75-1.34L9 15zm0-4L18 9.28 9 13 0 9.28 1.75 8 9 11zM9 0l9 4.92-9 4-9-4zm0 2.05L4.06 4.76 9 7l5-2.22z",
    "data-name": "\u672A\u9009\u4E2D/\u9700\u6C42\u7F16\u63921111"
  }))));
});

/**
* @file 图标cos-client
* @author zhanglili
*/
var IconCosClient =
/*#__PURE__*/
createIcon('cos-client', SVG$E);

var SVG$F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M455.8 123.9C266.1 151 120.2 314.2 120.2 511.5c0 216.3 175.3 391.6 391.6 391.6 197.3 0 360.5-145.9 387.6-335.7H455.8V123.9zm56-59.9v447.6h447.6c0 247.2-200.4 447.6-447.6 447.6S64.2 758.7 64.2 511.5 264.6 64 511.8 64z"
  }), React.createElement("path", {
    d: "M623.7 124.6v275.1h275.1c-23.6-140.6-134.6-251.6-275.1-275.1zm-56-60.6C784 64 959.3 239.3 959.3 455.6H567.7V64z"
  }));
});

/**
* @file 图标cov
* @author zhanglili
*/
var IconCOV =
/*#__PURE__*/
createIcon('cov', SVG$F);

var SVG$G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M923.341 564.293V460.922H815.835a313.724 313.724 0 0 0-51.686-128.18l72.877-78.562-72.36-73.91-75.978 79.079a302.375 302.375 0 0 0-127.146-51.686V99.123H458.171v107.506a313.724 313.724 0 0 0-128.18 51.686l-78.562-72.877-71.843 72.36 77.011 75.978a302.375 302.375 0 0 0-51.686 127.146H96.372v103.371h107.506a313.724 313.724 0 0 0 51.686 128.18l-72.877 78.562 72.36 73.91 75.978-77.528a302.356 302.356 0 0 0 127.146 50.135v108.54h103.371V818.586a313.736 313.736 0 0 0 128.18-51.685l78.562 72.877 73.91-72.36-77.528-75.978a302.356 302.356 0 0 0 50.135-127.146h108.54zM509.857 723.41c-116.423 0-210.803-94.38-210.803-210.803s94.38-210.803 210.803-210.803 210.803 94.38 210.803 210.803S626.28 723.41 509.857 723.41z"
  }));
});

/**
* @file 图标custom-nav
* @author zhanglili
*/
var IconCustomNav =
/*#__PURE__*/
createIcon('custom-nav', SVG$G);

var SVG$H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M914.57 37v950.86H110V37zm-73.14 658.28H183.14v219.43h658.29zm-512 73.15v73.14h-73.14v-73.14zm512-365.72H183.14v219.43h658.29zm-512 73.15V549h-73.14v-73.14zm512-365.72H183.14v219.43h658.29zm-512 73.15v73.14h-73.14v-73.14z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标database
* @author zhanglili
*/
var IconDatabase =
/*#__PURE__*/
createIcon('database', SVG$H);

var SVG$I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M987.86 987.86H37V37h950.86zM329.57 695.28H110.14v219.43h219.43zm292.57 0H402.71v219.43h219.43zm292.57 0H695.28v219.43h219.43zM329.57 402.71H110.14v219.43h219.43zm292.57 0H402.71v219.43h219.43zm292.57 0H695.28v219.43h219.43zM329.57 110.14H110.14v219.43h219.43zm292.57 0H402.71v219.43h219.43zm292.57 0H695.28v219.43h219.43z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标datatable
* @author zhanglili
*/
var IconDatatable =
/*#__PURE__*/
createIcon('datatable', SVG$I);

var SVG$J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props), React.createElement("path", {
    d: "M17.622 3c.402 0 .8.004 1.195.012l1.17.034.575.024 1.125.062 1.62.123 1.527.149.958.11.906.116 1.252.178.757.12 1.008.171 1.683.326.602.132-.284 3.379-.306 4.843-.087 1.2c-.217 2.723-.568 4.958-1.57 7.396-2.085 5.08-5.538 8.319-11.06 11.263L18 33c-5.916-3.05-9.564-6.343-11.733-11.625-.93-2.264-1.299-4.353-1.521-6.82l-.094-1.168-.348-5.451-.161-2.043-.123-1.32.953-.248.724-.153 1.245-.237 1.128-.188 1.28-.187 1.42-.175 1.02-.105 1.073-.093 1.123-.077 1.17-.06c.199-.007.4-.015.601-.021l1.234-.026.63-.003zm1.377 18.994l.003 8.185c4.396-2.544 6.998-5.25 8.678-9.04l.224-.523c.75-1.828 1.126-3.553 1.363-6.074l.062-.708.085-1.18.328-5.124.017-.219-5.6 4.699a6.805 6.805 0 0 0-1.08-1.705l5.258-4.411-.67-.106-1.222-.175-.881-.112-.925-.107-1.482-.145-1.58-.12-1.385-.073-1.414-.045L17.633 5l-.6.003-1.502.035-1.408.067-1.088.074-1.04.09-.98.101-1.377.17-1.239.18-.788.131 5.386 4.519a6.806 6.806 0 0 0-1.06 1.721L6.26 7.33l.065.849.32 5.049.092 1.148c.233 2.588.611 4.37 1.379 6.24 1.667 4.06 4.296 6.895 8.882 9.56l-.001-8.179-3.362.004c-2.458 0-4.463-1.94-4.625-4.386L9 17.292a4.7 4.7 0 0 1 2.213-3.998l.297-.169.094-.047.047-.181c.08-.276.175-.545.286-.805l1.633 1.371-.063.248-.05.254-.1.582-.558.194A2.69 2.69 0 0 0 11 17.292c0 1.412 1.05 2.565 2.383 2.696l.253.012L17 19.996v2l1.999-.002zm5.161-9.982c.088.2.167.404.237.614l.096.318.051.206.127.068a4.7 4.7 0 0 1 2.274 3.353l.041.357.014.364c0 2.456-1.857 4.478-4.253 4.684l-.316.017-3.431.003v-2l3.412-.003c1.253-.023 2.295-.941 2.536-2.161l.039-.266.013-.274a2.704 2.704 0 0 0-1.451-2.409l-.247-.112-.529-.208-.092-.56a4.902 4.902 0 0 0-.145-.63l1.624-1.361zM18.067 8c1.89 0 3.611.803 4.833 2.106l.18.199-1.533 1.286a4.652 4.652 0 0 0-2.673-1.52l-.46 4.195 3.358-.34L17 21l.415-4.604L14 16.78l4.344-6.772a4.631 4.631 0 0 0-3.816 1.648l-1.53-1.287a6.644 6.644 0 0 1 4.267-2.32l.427-.038.375-.011z"
  }));
});

/**
* @file 图标ddo-s
* @author zhanglili
*/
var IconDDoS =
/*#__PURE__*/
createIcon('ddo-s', SVG$J);

var SVG$K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M354 129h320v64H354zM126 264h771v64H126zm166 64v503h444V328h64v567H228V328z"
  }), React.createElement("path", {
    d: "M545 456.5v256h-64v-256z"
  }));
});

/**
* @file 图标delete
* @author zhanglili
*/
var IconDelete =
/*#__PURE__*/
createIcon('delete', SVG$K);

var SVG$L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M159.6 717.8h765.6v58.9H159.6zM336.2 835.6h353.4v58.9H336.2zM100.7 128.9h824.5v58.9H100.7v-58.9z"
  }), React.createElement("path", {
    d: "M866.3 128.9h58.9v294.5h-58.9zm-765.6 0h58.9v647.8h-58.9zm765.6 412.2h58.9v176.7h-58.9zm-238-88.3l-176.7 88.3V364.5l176.7 88.3z"
  }), React.createElement("path", {
    d: "M512.9 658.9c113.8 0 206.1-92.3 206.1-206.1s-92.3-206.1-206.1-206.1S306.8 339 306.8 452.8s92.3 206.1 206.1 206.1zm0-58.9c-81.3 0-147.2-65.9-147.2-147.2s65.9-147.2 147.2-147.2 147.2 65.9 147.2 147.2S594.2 600 512.9 600z"
  }));
});

/**
* @file 图标demo
* @author zhanglili
*/
var IconDemo =
/*#__PURE__*/
createIcon('demo', SVG$L);

var SVG$M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M14.88 11a7.51 7.51 0 0 1-13.76 0h1.11a6.52 6.52 0 0 0 2.93 2.85A8.14 8.14 0 0 1 3.87 11h1c.6 2.09 1.8 3.5 3.1 3.5s2.5-1.41 3.1-3.5h1a8.14 8.14 0 0 1-1.29 2.85A6.52 6.52 0 0 0 13.77 11zm-2.52-4.74a1.64 1.64 0 0 1 1.11.44l-.41.52a1.12 1.12 0 0 0-.7-.26c-.25 0-.41.1-.41.28s.22.26.52.38l.42.17a1 1 0 0 1 .68.93c0 .57-.48 1.06-1.3 1.06A1.87 1.87 0 0 1 11 9.27l.46-.56a1.35 1.35 0 0 0 .83.35c.3 0 .44-.11.44-.3s-.19-.26-.48-.38l-.43-.18a1 1 0 0 1-.69-.94 1.12 1.12 0 0 1 .4-.76 1.13 1.13 0 0 1 .83-.24zm-7.68.47A1.53 1.53 0 0 1 5.11 8a1.53 1.53 0 0 1-.43 1.25 1.51 1.51 0 0 1-1.24.45h-1V6.3h1a1.53 1.53 0 0 1 1.24.43zm2.89-.43l.85 1.63.33.75a10.71 10.71 0 0 1-.11-1.26V6.3h.77v3.4h-.8l-.84-1.64-.33-.75c0 .38.1.85.1 1.26V9.7h-.8V6.3zm-4.23.64h-.11V9h.11c.55 0 .94-.25.94-1.06s-.39-1-.94-1zM8 .5A7.5 7.5 0 0 1 14.88 5h-1.11a6.52 6.52 0 0 0-2.93-2.85A8.22 8.22 0 0 1 12.13 5h-1c-.58-2-1.71-3.39-2.95-3.49H8C6.7 1.5 5.5 2.91 4.9 5h-1a8.22 8.22 0 0 1 1.26-2.85A6.57 6.57 0 0 0 2.23 5H1.12A7.5 7.5 0 0 1 8 .5z"
  }))));
});

/**
* @file 图标dns
* @author zhanglili
*/
var IconDNS =
/*#__PURE__*/
createIcon('dns', SVG$M);

var SVG$N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512 781.8l72.62-72.64 145.25-145.28-72.62-72.64-93.37 93.39V96.92H460.13v487.72l-93.37-93.39-72.62 72.64 145.25 145.28L512 781.8zM97 823.31h830v103.77H97V823.31z"
  }));
});

/**
* @file 图标download
* @author zhanglili
*/
var IconDownload =
/*#__PURE__*/
createIcon('download', SVG$N);

var SVG$O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M959.333 512.136c0-247.606-200.724-448.33-448.33-448.33S62.672 264.53 62.672 512.136s200.724 448.331 448.33 448.331v-68.974c-209.513 0-379.357-169.844-379.357-379.357S301.49 132.779 511.003 132.779 890.36 302.623 890.36 512.136h68.973z"
  }), React.createElement("path", {
    d: "M823.138 646.037L577.011 887.445l48.298 49.242 246.127-241.409zM442.029 236.24h68.974v275.896h-68.974z"
  }), React.createElement("path", {
    d: "M442.029 443.162h275.896v68.974H442.029zm68.974 206.922h206.922v68.973H511.003z"
  }), React.createElement("path", {
    d: "M579.977 581.11h68.974v206.921h-68.974zm137.948 275.895h206.921v68.974H717.925z"
  }));
});

/**
* @file 图标dstream
* @author zhanglili
*/
var IconDSTREAM =
/*#__PURE__*/
createIcon('dstream', SVG$O);

var SVG$P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M11 14v1H5v-1zm-9-2h12V9h1v4H1V2h14v5h-1V3H2zm10.3-4l-4.64 3.39-.59-.8L9.24 9H3.77V8zM8.41 3.6l.59.8L6.83 6h5.47v1H3.77z"
  }))));
});

/**
* @file 图标dts
* @author zhanglili
*/
var IconDTS =
/*#__PURE__*/
createIcon('dts', SVG$P);

var SVG$Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M575.9 894.4L895 741.2V279.3L575.9 128.4V64.5l383 176.1v538.8l-383 178.7v-63.7zm-127.7 0v63.8l-383-178.7V240.6l383-176.1v63.8L129 279.3v461.9l319.2 153.2zM192.8 671.2v-319l319.2-160 319.2 160v318.3l-318.8 160-319.6-159.3zm349.8-136.1l-.8 207.4 225.5-112.7V422.4L542.6 535.1zm-285.9 95.1l217.8 113.1.8-206.8-218.6-113.8v207.5zm31.9-263.9L512 483.6l223.4-117.3L512 250 288.6 366.3z"
  }));
});

/**
* @file 图标eci
* @author zhanglili
*/
var IconEci =
/*#__PURE__*/
createIcon('eci', SVG$Q);

var SVG$R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M960.4 959.4H99.2V98.2h574.1V170H170.9v717.6h717.7V385.2h71.8z"
  }), React.createElement("path", {
    d: "M899.093 108.79l50.77 50.771-628.418 628.395-50.77-50.771z"
  }));
});

/**
* @file 图标edit
* @author zhanglili
*/
var IconEdit =
/*#__PURE__*/
createIcon('edit', SVG$R);

var SVG$S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M13.041 15.012H2.979V7.977H1.053v-.969L7.999.932l7.014 6.075v.971h-1.971v7.034zm-9.062-1h8.062V6.977h1.41l-5.449-4.72-5.395 4.72H3.98v7.035zM1.553 7.234h.5v.227l-.018.016h-.27l-.212-.243zm12.459 0h.5l-.21.243h-.274l-.016-.014v-.229z"
  }), React.createElement("path", {
    d: "M5 7h6v1H5zm0 2h6v1H5zm0 2h6v1H5z"
  }));
});

/**
* @file 图标edw
* @author zhanglili
*/
var IconEDW =
/*#__PURE__*/
createIcon('edw', SVG$S);

var SVG$T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M1 1h4v4H1V1zm1 1v2h2V2H2zM11 1h4v4h-4V1zm1 1v2h2V2h-2zM11 11h4v4h-4v-4zm1 1v2h2v-2h-2zM1 11h4v4H1v-4zm1 1v2h2v-2H2zM2.5 5v6h1V5zM9.3 10.1l-.2.1c-.4.2-.8.3-1.2.3-1.4 0-2.5-1.1-2.5-2.5v-.3l.4.1-.2-1V5.6L4 7.2l.5.2c0 .2-.1.4-.1.6 0 1.9 1.6 3.5 3.5 3.5.7 0 1.3-.2 1.9-.5l-.5-.9zm1.8-.4l.8-.9-.5-.1c0-.2.1-.4.1-.7 0-1.9-1.6-3.5-3.5-3.5-.7 0-1.3.2-1.9.5l.5.8.2-.1c.4-.1.8-.2 1.2-.2 1.4 0 2.5 1.1 2.5 2.5 0 .1 0 .3-.1.4l-.4-.2.4 2.2.7-.7z"
  }), React.createElement("path", {
    d: "M6.3 8.9l1-.9 1.1.9 1.7-1.5-.7-.8-1.1 1-1-.9-1.6 1.5zM5 3.5h6v-1H5zM12.5 5v6h1V5zM5 13.5h6v-1H5z"
  }));
});

/**
* @file 图标eks
* @author zhanglili
*/
var IconEKS =
/*#__PURE__*/
createIcon('eks', SVG$T);

var SVG$U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M15 1v14H1V1zm-1 4H2v9h12zm-7 5v3H3v-3zm6 2v1H8v-1zm-7-1H4v1h2zm7-1v1H8v-1zm0-4v3H3V6zm-1 1H4v1h8zm2-5H2v2h12z"
  }))));
});

/**
* @file 图标ens
* @author zhanglili
*/
var IconENS =
/*#__PURE__*/
createIcon('ens', SVG$U);

var SVG$V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M927 97v830H97V97h830zm-64 64H161v702h702V161zM735 671v64H470v-64h265zM333 304.11L540.89 512 333 719.89l-45.255-45.255L450.38 512 287.745 349.365 333 304.111z"
  }));
});

/**
* @file 图标env
* @author zhanglili
*/
var IconEnv =
/*#__PURE__*/
createIcon('env', SVG$V);

var SVG$W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M12 4h3v11H1V4h3V1h8zm-1-2H5v12h6zM4 5H2v9h2zm8 9h2V5h-2zm-2-5v1H6V9zm0-2v1H6V7zm0-2v1H6V5z"
  }))));
});

/**
* @file 图标epc
* @author zhanglili
*/
var IconEPC =
/*#__PURE__*/
createIcon('epc', SVG$W);

var SVG$X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("g", {
    "data-name": "2021\u5E74Q3\u652F\u51FA"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M374.08 79c27.68 0 54.53 1.34 80.11 3.85l21.61 2.44 20.92 3c113.08 17.93 192.43 59.92 192.43 108.86a44 44 0 0 1-.35 5.63v231.45l-.9.08q10.36-.84 21-.85c141.38 0 256 114.62 256 256s-114.62 256-256 256a254.85 254.85 0 0 1-151.07-49.3l.63.46a626.18 626.18 0 0 1-459.66-36q-16.31-10.23-23.26-16.09-6.22-5.24-16.29-17.18v-626c-.12-1.39-.19-2.78-.19-4.19 0-48.94 79.35-90.93 192.43-108.86l20.93-3L294 82.85c25.54-2.51 52.39-3.85 80.08-3.85zm334.77 413.54c-108.76 0-196.93 88.16-196.93 196.92s88.17 196.92 196.93 196.92 196.92-88.16 196.92-196.92-88.17-196.92-196.92-196.92zM118.27 672.81v128.3C240.19 864.64 375.8 881 504.92 850.2l3.91-1-.76-1a254.78 254.78 0 0 1-53-125l-.19-1.45v.32a626.2 626.2 0 0 1-336.61-49.26zm603.82-121.19l87.09 86.92.18-.18L849.7 679 717.45 812.53l-41.78-41.77 63.23-62.62H571v-53.58h170.61l-61.3-61.17zm-603.82-95.43v151.2a567.12 567.12 0 0 0 332.56 55.76l3.4-.48-.08.84.21-2.06a255.75 255.75 0 0 1 100.52-176.53l1.7-1.28-4.28 1.29a626.23 626.23 0 0 1-434.03-28.74zm511.63-190c-33.58 17.48-79.59 31.38-133.18 39.88l-20.92 3-21.61 2.44c-25.58 2.52-52.43 3.86-80.11 3.86S319.54 314 294 311.45L272.36 309l-20.93-3c-53.57-8.5-99.58-22.39-133.16-39.87v124.65a567.12 567.12 0 0 0 511.59 0zM374.08 138.08c-78 0-150.44 11.49-202 30.84-22.45 8.42-39.28 17.76-49.08 26.45l-2 1.78 2 1.79c9.8 8.69 26.63 18 49.08 26.45 51.61 19.35 124 30.84 202 30.84s150.43-11.49 202.05-30.84c22.45-8.42 39.27-17.76 49.07-26.45l2-1.79-2-1.78c-9.8-8.69-26.62-18-49.07-26.45-51.62-19.35-124.06-30.84-202.05-30.84z"
  })))));
});

/**
* @file 图标expend
* @author zhanglili
*/
var IconExpend =
/*#__PURE__*/
createIcon('expend', SVG$X);

var SVG$Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.8 639.2c67.5 0 122.1-54.5 122.1-122.1 0-11.7-1.6-22.9-4.7-33.6L475.8 633.8c11.4 3.5 23.4 5.4 36 5.4z"
  }), React.createElement("path", {
    d: "M804.6 311.6L691.7 422.2c15 28.3 23.5 60.6 23.5 94.9 0 112.3-91.1 203.4-203.4 203.4-35.7 0-69.3-9.2-98.5-25.4l-90.4 88.6c58 24.8 121.8 38.6 188.9 38.6 203.4 0 377.2-126.5 447.6-305.2-32.3-81.8-86.2-152.7-154.8-205.5zM789 159.2l-91.7 89.9C640.2 225.2 577.5 212 511.8 212c-203.4 0-377.2 126.5-447.6 305.2 31.8 80.7 84.7 150.8 152 203.4l-65.3 64 41.9 42.8L830.9 202 789 159.2zM308.3 517.1c0-112.3 91.1-203.4 203.4-203.4 34.4 0 66.9 8.6 95.3 23.7l-63.2 61.9c-10.2-2.8-21-4.3-32.2-4.3-67.5 0-122.1 54.5-122.1 122.1 0 10.3 1.3 20.2 3.6 29.8l-63.2 61.9c-13.7-27.6-21.6-58.7-21.6-91.7z"
  }));
});

/**
* @file 图标eye-ignore
* @author zhanglili
*/
var IconEyeIgnore =
/*#__PURE__*/
createIcon('eye-ignore', SVG$Y);

var SVG$Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513 127.459c210.643 0 381.541 170.899 381.541 381.541S723.643 890.541 513 890.541 131.459 719.643 131.459 509 302.357 127.459 513 127.459m0-63.591C267.383 63.868 67.868 263.383 67.868 509S267.383 954.132 513 954.132 958.132 754.617 958.132 509 758.617 63.868 513 63.868z"
  }), React.createElement("path", {
    d: "M481.205 704.048h63.59v63.59h-63.59v-63.59zm0-446.86h63.59v381.541h-63.59V257.188z"
  }));
});

/**
* @file 图标fail-circle-o
* @author zhanglili
*/
var IconFailCircleO =
/*#__PURE__*/
createIcon('fail-circle-o', SVG$Z);

var SVG$_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.3 63.9c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zM462.1 266c0-5.5 4.5-10 10-10h80.2c5.5 0 10 4.5 10 10v300c0 5.5-4.5 10-10 10h-80.2c-5.5 0-10-4.5-10-10V266zm52.5 497.1c-34 0-61.5-27.6-61.5-61.5s27.6-61.5 61.5-61.5 61.5 27.6 61.5 61.5-27.5 61.5-61.5 61.5z"
  }));
});

/**
* @file 图标fail-circle-solid
* @author zhanglili
*/
var IconFailCircleSolid =
/*#__PURE__*/
createIcon('fail-circle-solid', SVG$_);

var SVG$$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M157.817 159.283l-.77 534.784h178.866V812.29l158.299-118.223h374.879l.77-534.784H157.817zM98.566 99.946h830.717l-.94 653.457H513.924l-237.348 177.26v-177.26H97.625l.941-653.457z"
  }), React.createElement("path", {
    d: "M396.583 515.378h-29.632c-16.406 0-29.705-13.299-29.705-29.705s13.299-29.705 29.705-29.705h29.632v59.41zm0-118.747h-29.632c-49.177 0-89.042 39.866-89.042 89.042s39.866 89.042 89.042 89.042h88.969V277.957h-59.337v118.674z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M751.272 396.631h59.337v59.337h-59.337zm0 118.674h59.337v59.337h-59.337zM513.924 396.631h59.208l-.045 89.202c0 22.844 7.679 29.472 17.714 29.472h41.763V396.631h59.37v178.011H580.05c-45.474 0-66.126-28.996-66.126-71.66V396.631z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标feedback
* @author zhanglili
*/
var IconFeedback =
/*#__PURE__*/
createIcon('feedback', SVG$$);

var SVG$10 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1025 1025"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M927.5 97.5L650.83 443.26V927.5l-271-138.33-5.67-345.91L97.5 97.5zm-133.18 64H230.68L437.8 420.35l5.4 329.3L586.83 823V420.81z",
    "data-name": "\u8868\u683C/\u8868\u5934/\u7B5B\u9009"
  }))));
});

/**
* @file 图标filter
* @author zhanglili
*/
var IconFilter =
/*#__PURE__*/
createIcon('filter', SVG$10);

var SVG$11 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("path", {
    d: "M11 1.833a9.167 9.167 0 1 1 0 18.334 9.167 9.167 0 0 1 0-18.334zm0 1.93a7.237 7.237 0 1 0 0 14.474 7.237 7.237 0 0 0 0-14.474zm-.046 2.654l4.537 4.537-4.537 4.537-4.537-4.537 4.537-4.537zm0 2.728l-1.808 1.808 1.808 1.808 1.808-1.808-1.808-1.808z"
  }));
});

/**
* @file 图标finance
* @author zhanglili
*/
var IconFinance =
/*#__PURE__*/
createIcon('finance', SVG$11);

var SVG$12 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M98 98.2h592.9v296.4H98V98.2zm59.3 59.3v177.9h474.3V157.5H157.3zm177.8 474.2h592.7V928H335.1V631.7zm59.3 59.2v177.8h474.2V690.9H394.4z"
  }), React.createElement("path", {
    d: "M631.6 98.2H928v592.9H631.6V98.2zm59.3 59.3v474.3h177.9V157.5H690.9zM98 335.4h296.4v592.9H98V335.4zm59.3 59.3V869h177.9V394.7H157.3z"
  }));
});

/**
* @file 图标front-end
* @author zhanglili
*/
var IconFrontEnd =
/*#__PURE__*/
createIcon('front-end', SVG$12);

var SVG$13 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M374.08 79c27.68 0 54.53 1.34 80.11 3.85l21.61 2.44 20.92 3c113.08 17.93 192.43 59.92 192.43 108.86a44 44 0 0 1-.35 5.63v231.45l-.9.08q10.36-.84 21-.85c141.38 0 256 114.62 256 256s-114.62 256-256 256a254.85 254.85 0 0 1-151.07-49.3l.63.46a626.18 626.18 0 0 1-459.66-36q-16.31-10.23-23.26-16.09-6.22-5.24-16.29-17.18v-626c-.12-1.39-.19-2.78-.19-4.19 0-48.94 79.35-90.93 192.43-108.86l20.93-3L294 82.85c25.54-2.51 52.39-3.85 80.08-3.85zm508.28 517.25L570.81 829.91a196.29 196.29 0 0 0 138 56.47c108.75 0 196.92-88.16 196.92-196.92a196.15 196.15 0 0 0-23.37-93.21zm-764.09 76.56v128.3c123.15 64.17 260.27 80.21 390.56 48.14l.12.15a254.73 254.73 0 0 1-54.43-130.47c.13 1.09.26 2.18.4 3.27a626.2 626.2 0 0 1-336.65-49.39zm590.58-180.27c-108.76 0-196.93 88.16-196.93 196.92a196 196 0 0 0 23.42 93.21L846.88 549a196.29 196.29 0 0 0-138.03-56.46zm-590.58-36.35v151.2a567.12 567.12 0 0 0 332.56 55.76l3.4-.48-.18 1.76c-.12 1.26-.23 2.53-.34 3.8a255.75 255.75 0 0 1 102.89-184.6 626.26 626.26 0 0 1-438.33-27.44zm511.63-190c-33.58 17.48-79.59 31.38-133.18 39.88l-20.92 3-21.61 2.44c-25.58 2.52-52.43 3.86-80.11 3.86S319.54 314 294 311.45L272.36 309l-20.93-3c-53.57-8.5-99.58-22.39-133.16-39.87v124.65a567.12 567.12 0 0 0 511.59 0zM374.08 138.08c-78 0-150.44 11.49-202 30.84-22.45 8.42-39.28 17.76-49.08 26.45l-2 1.78 2 1.79c9.8 8.69 26.63 18 49.08 26.45 51.61 19.35 124 30.84 202 30.84s150.43-11.49 202.05-30.84c22.45-8.42 39.27-17.76 49.07-26.45l2-1.79-2-1.78c-9.8-8.69-26.62-18-49.07-26.45-51.62-19.35-124.06-30.84-202.05-30.84z"
  }))));
});

/**
* @file 图标frozen-amount
* @author zhanglili
*/
var IconFrozenAmount =
/*#__PURE__*/
createIcon('frozen-amount', SVG$13);

var SVG$14 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M564.7 98.2v103.4h185.5L528.1 423.7l73.1 73.3 222.2-222.2v185.5h103.4V98.2zM202.5 749.4V563.8H99V926h362.2V822.5H275.6l222.2-222.1-73.2-73.2z"
  }));
});

/**
* @file 图标full-screen
* @author zhanglili
*/
var IconFullScreen =
/*#__PURE__*/
createIcon('full-screen', SVG$14);

var SVG$15 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M8 1c3.314 0 5.527 1.12 5.527 2.5S11.314 6 8 6 2.44 4.88 2.44 3.5 4.685 1 8 1zm0 1c-2.743 0-4.56.843-4.56 1.5S5.256 5 8 5c2.737 0 4.527-.837 4.527-1.5S10.737 2 8 2z"
  }), React.createElement("path", {
    d: "M3.5 3.159v8.738c0 .868 1.329 1.48 3.32 1.762l.242.033-.124.992c-2.556-.32-4.317-1.06-4.432-2.622l-.006-.165V3.16h1zm10 0v4.246h-1V3.159h1zM11 8c1.262 0 2.286.977 2.286 2.182v.02c.969.131 1.714.927 1.714 1.889v.08c0 1.01-.858 1.829-1.915 1.829H9c-1.105 0-2-.855-2-1.91 0-.96.745-1.757 1.714-1.889v-.02C8.714 8.978 9.738 8 11 8zm.01.897c-.691 0-1.25.469-1.25 1.205v.747l-.935.055c-.509.077-.892.545-.892 1.1 0 .766.57 1.11 1.145 1.11h3.83c.541 0 1.15-.4 1.15-1.11 0-.71-.515-1.1-1.06-1.1l-.739-.055v-.747c0-.736-.56-1.205-1.25-1.205z"
  }), React.createElement("path", {
    d: "M3.325 6.716c.87.746 2.306 1.153 4.315 1.196l.36.004v1c-2.288 0-4.003-.421-5.141-1.291l-.184-.15.65-.759zm-.093 2.728c.773.722 1.634 1.105 2.602 1.16l.244.006v1c-1.237 0-2.35-.42-3.323-1.251l-.206-.185.683-.73z"
  }));
});

/**
* @file 图标gaia-db
* @author zhanglili
*/
var IconGaiaDB =
/*#__PURE__*/
createIcon('gaia-db', SVG$15);

var SVG$16 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M16.63 24a.489.489 0 0 1-.054-.003c-.075-.008-1.766-.206-2.852-1.568h-.578a9.253 9.253 0 0 1-2.029-.302l-.389-.117a6.256 6.256 0 0 1-3.779 1.071.5.5 0 0 1-.432-.284c-.033-.07-.776-1.663-.213-3.623a9.512 9.512 0 0 1-1.146-1.576c-.684-.11-2.474-.562-4.038-2.385a.501.501 0 0 1-.102-.464c.028-.097.688-2.311 2.858-3.513l.012-.057a9.944 9.944 0 0 1 .396-1.813l.081-.234c-.411-.613-1.283-2.211-1.116-4.545a.498.498 0 0 1 .268-.407c.091-.049 2.235-1.146 4.716-.271.158-.104.326-.207.514-.313.281-.153.533-.28.806-.407.062-.031.143-.063.224-.095.051-.019.102-.038.148-.061.117-.06.25-.105.374-.146l.113-.035c.167-.499.724-1.775 2.26-2.772a.5.5 0 0 1 .487-.032c.067.032 1.57.765 2.226 2.457.227.039.414.076.589.124.125.021.293.071.461.123l.207.062c.247.089.437.159.605.225.47-.28 1.268-.597 2.373-.528a.504.504 0 0 1 .39.232c.031.05.725 1.167.503 2.524l.017.018c.145.155.286.308.418.469.537.635.914 1.321 1.15 1.782.302.652.505 1.202.629 1.699.134.539.196 1.029.234 1.395a.452.452 0 0 1 .002.082c.009.134.014.259.018.379.005.129.01.251.019.368.002.423-.289.723-.66.723a.697.697 0 0 1-.663-.504l-.053-.184a7.926 7.926 0 0 0-.16-.521c-.06-.18-.114-.348-.189-.517l.398-.342-.452.213-.044-.1h.001c-.044-.063-.07-.123-.087-.16a2.298 2.298 0 0 1-.026-.057l-.016-.028a.609.609 0 0 1-.026-.055 7.047 7.047 0 0 0-1.271-1.812l.288-.431-.354.353a1.365 1.365 0 0 1-.073-.079 1.085 1.085 0 0 1-.078-.074 1.567 1.567 0 0 1-.162-.143.525.525 0 0 1-.138-.14.715.715 0 0 1-.027-.029l-.002.001a6.999 6.999 0 0 0-1.508-1.002c-.58-.3-1.175-.5-1.824-.616a8.454 8.454 0 0 0-1.013-.116l-.715.001c-.07.02-.174.02-.25.02h-.059c-.08.02-.143.02-.184.02a.835.835 0 0 1-.162.02.55.55 0 0 1-.161.021c-.013.004-.029.009-.048.012l-.133.034a.506.506 0 0 1-.123.016.67.67 0 0 1-.144.017.69.69 0 0 1-.115.032 1.817 1.817 0 0 1-.23.067 1.063 1.063 0 0 1-.195.055c-.04.021-.095.032-.139.041-.18.061-.347.117-.514.191l-.331-.402.221.448-.367-.385.225.447c-.133.057-.201.091-.271.125-.178.081-.315.169-.454.256-.14.088-.253.186-.287.221a4.627 4.627 0 0 0-.448.39c-.491.495-.934 1.146-1.279 1.88a9.223 9.223 0 0 0-.416 1.144l-.032.118c-.045.165-.089.322-.119.491l-.02.108c-.03.168-.061.329-.076.501a3.64 3.64 0 0 0-.059.607v.632c.016.386.079.778.182 1.122.095.317.229.73.431 1.115.175.336.392.673.663 1.032a6.206 6.206 0 0 0 1.847 1.536c.347.183.724.335 1.114.448.4.116.794.19 1.203.228.121.021.204.017.279.018h.323c.176 0 .35-.017.503-.05.395-.061.753-.199 1.085-.339a4.468 4.468 0 0 0 1.695-1.406c.224-.301.472-.795.512-.929l.084-.265c.038-.115.075-.225.088-.282l.062-.308c.007-.035.01-.069.014-.104.006-.067.014-.135.027-.202-.011.029-.004-.033.002-.102a.928.928 0 0 0 .008-.105v-.531c-.004.025-.01-.023-.018-.087l-.014-.099a3.282 3.282 0 0 0-.302-.96 3.24 3.24 0 0 0-1.309-1.372c-.41-.23-.862-.37-1.342-.412a.561.561 0 0 1-.041.001h-.162c-.122.014-.183.02-.243.02-.102 0-.235.034-.363.066a2.485 2.485 0 0 0-.39.137 1.854 1.854 0 0 0-.333.193c-.133.08-.22.148-.322.252-.389.375-.64.853-.733 1.386l-.53.084.497.057v.223c-.016.143 0 .247.016.357.033.223.101.425.2.596.119.204.25.367.41.512.144.145.311.257.5.345.149.069.336.123.57.167a.39.39 0 0 1 .049.012h.367a.583.583 0 0 1 .14-.02c-.031-.001-.001-.011.029-.02.065-.02.131-.039.197-.052a.785.785 0 0 0 .132-.055l.004.006a.52.52 0 0 1 .081-.05l.036-.016a.798.798 0 0 1 .847.17c.141.17.197.333.197.497a.736.736 0 0 1-.287.581c-.182.138-.31.217-.463.294-.114.044-.164.065-.214.086-.071.03-.144.059-.215.083l-.127.039a2.141 2.141 0 0 1-.125.032.672.672 0 0 1-.129.031.69.69 0 0 1-.184.026h-.425a2.91 2.91 0 0 1-1.062-.146 4.127 4.127 0 0 1-1.06-.51 3.777 3.777 0 0 1-.929-.887 3.998 3.998 0 0 1-.764-1.941c-.028-.109-.028-.194-.028-.26v-.49a5.006 5.006 0 0 1 .315-1.502 4.61 4.61 0 0 1 .817-1.394 5.065 5.065 0 0 1 1.279-1.104 5.037 5.037 0 0 1 1.663-.633l.426-.065.476-.005c.274 0 .586 0 .889.047.61.069 1.212.239 1.738.493a6.033 6.033 0 0 1 1.575 1.017c.479.432.893.931 1.239 1.488a6.47 6.47 0 0 1 .757 1.871c.019.126.031.19.044.255.018.088.035.177.046.271l.029.172c.036.109.036.204.036.255v.592c0 .183-.001.342-.023.523.339.314 1.021 1.087 1.231 2.44a.499.499 0 0 1-.144.433c-.042.042-1.001.97-2.411 1.004a7.655 7.655 0 0 1-1.274 1.483c-.191.161-.378.306-.562.447-.025.504-.218 1.748-1.407 3.028a.48.48 0 0 1-.365.165zm-2.653-2.571c.165 0 .319.081.412.217.613.893 1.599 1.21 2.053 1.312.916-1.093.965-2.079.965-2.275v-.123c0-.157.073-.304.198-.398.258-.196.484-.366.71-.556.383-.337.756-.775 1.164-1.369.058-.084.095-.146.154-.207a.482.482 0 0 1 .39-.152c.784.045 1.425-.33 1.731-.555-.251-1.093-.874-1.592-.949-1.649a1.956 1.956 0 0 1-.114-.109.499.499 0 0 1-.144-.351c0-.057.005-.114.012-.173 0-.021.009-.133.012-.154.018-.141.017-.265.017-.407v-.573a.42.42 0 0 1-.014-.059l-.041-.245a2.976 2.976 0 0 0-.037-.219 3.192 3.192 0 0 1-.046-.274 5.558 5.558 0 0 0-.628-1.525 5.813 5.813 0 0 0-1.049-1.26 5.081 5.081 0 0 0-1.3-.845 4.603 4.603 0 0 0-1.463-.42c-.282-.042-.532-.038-.776-.04h-.405l-.324.055a4.017 4.017 0 0 0-2.35 1.398 3.605 3.605 0 0 0-.636 1.073 4.098 4.098 0 0 0-.262 1.202l.001.466c.012.035.015.075.018.112a2.97 2.97 0 0 0 .576 1.491l.034.045c-.015-.023-.028-.046-.042-.07a2.696 2.696 0 0 1-.325-.953c-.023-.163-.052-.36-.021-.574l-.005-.154c0-.132.026-.232.047-.312a3.504 3.504 0 0 1 1.017-1.925c.161-.161.317-.284.486-.381a2.53 2.53 0 0 1 .475-.27c.164-.071.354-.142.543-.189.178-.045.381-.097.607-.097.12-.014.182-.02.243-.02h.171c.037.002.104.001.115.002a4.307 4.307 0 0 1 1.752.538c.752.43 1.36 1.07 1.714 1.804a4.3 4.3 0 0 1 .411 1.387l.014.099.01.63c0 .066-.006.134-.012.201a.928.928 0 0 0-.008.105c-.017.133-.02.168-.023.203a1.997 1.997 0 0 1-.027.202l-.062.305c-.014.07-.062.229-.117.397l-.079.24c-.078.263-.386.862-.666 1.236a5.472 5.472 0 0 1-2.06 1.712c-.442.187-.87.35-1.345.422a3.334 3.334 0 0 1-.683.067h-.296c-.159 0-.315-.003-.448-.029a7.127 7.127 0 0 1-2.65-.783 7.187 7.187 0 0 1-2.15-1.788 8.355 8.355 0 0 1-.772-1.198 7.224 7.224 0 0 1-.502-1.292A5.762 5.762 0 0 1 6.974 13v-.663c0-.231.022-.486.068-.741.013-.161.047-.349.083-.547l.019-.105c.035-.2.086-.384.139-.579l.032-.116c.068-.249.277-.883.477-1.308.398-.849.895-1.575 1.475-2.159a4.45 4.45 0 0 1 .5-.436 2.32 2.32 0 0 1 .399-.31c.19-.119.369-.229.566-.318.07-.037.164-.083.281-.13.03-.017.088-.045.172-.073a.53.53 0 0 1 .142-.061c.151-.07.348-.138.546-.204L12 5.215c.041-.021.101-.033.146-.042a.67.67 0 0 1 .157-.047c.034-.008.075-.016.109-.029.027-.011.126-.04.155-.045.071-.036.092-.03.172-.031A.454.454 0 0 1 12.882 5a.594.594 0 0 1 .046-.012l.134-.034a.506.506 0 0 1 .123-.016.503.503 0 0 1 .143-.02.55.55 0 0 1 .161-.021.93.93 0 0 1 .115-.018.494.494 0 0 1 .147-.022h.142c.05-.016.11-.02.162-.02h.83c.42.022.801.066 1.161.13.75.134 1.437.365 2.1.708.613.303 1.16.665 1.665 1.101.026.021.073.058.12.115.02.015.049.041.08.078.023.021.047.043.069.066.063.048.113.094.161.143a.58.58 0 0 1 .142.146.872.872 0 0 1 .145.167c.367.369.716.82 1.021 1.318a11.217 11.217 0 0 0-.35-.836c-.205-.398-.545-1.017-1.021-1.581-.124-.152-.251-.287-.38-.426l-.196-.213a.5.5 0 0 1-.114-.458c.188-.749-.052-1.45-.209-1.795-.857.006-1.417.312-1.687.507a.501.501 0 0 1-.513.044l-.143-.061c-.152-.061-.355-.135-.56-.21l-.235-.071c-.131-.04-.261-.081-.392-.105-.234-.063-.444-.098-.654-.134-.045-.001-.11-.017-.145-.025-.22 0-.354-.139-.419-.349-.338-1.101-1.156-1.743-1.563-2.005-1.341.978-1.631 2.144-1.644 2.195h-.001a.866.866 0 0 1-.062.197.501.501 0 0 1-.348.262c-.146.046-.211.067-.283.082-.101.037-.185.062-.258.099-.075.038-.156.07-.237.102-.051.019-.102.038-.148.061-.266.124-.501.243-.756.381a7.915 7.915 0 0 0-.634.4l-.033.025-.012.008h-.001a.525.525 0 0 1-.6-.033c-1.634-.595-3.14-.141-3.72.087-.067 2.189.886 3.53 1.086 3.786a.5.5 0 0 1 .074.481l-.073.212a5.831 5.831 0 0 1-.09.26 9.343 9.343 0 0 0-.351 1.612c-.003.018-.012.087-.016.104a2.011 2.011 0 0 1-.044.276.499.499 0 0 1-.262.321c-1.542.763-2.252 2.19-2.485 2.767 1.605 1.718 3.41 1.856 3.429 1.857.17.011.325.108.407.257.266.481.555.912.884 1.316.096.124.193.229.292.337l.159.176c.12.136.157.325.098.496a4.558 4.558 0 0 0-.026 2.87c1.632-.03 2.706-.777 3.01-1.018a.5.5 0 0 1 .455-.086l.608.184a8.274 8.274 0 0 0 1.776.265l.815-.001zm6.642-7.44zm1.245-3.994l-.194.117.206-.048-.012-.069zm-.736.097l.002.001-.002-.001zm-.084-.126a.114.114 0 0 0 .006.014l-.006-.014zm-7.516-5.055c-.001 0-.001 0 0 0-.001 0-.001 0 0 0z"
  }), React.createElement("path", {
    d: "M11.452 15.618a.5.5 0 0 1-.395-.193l-.007-.009a.498.498 0 0 1 .128-.729.5.5 0 0 1 .689.154.5.5 0 0 1-.415.777z"
  }));
});

/**
* @file 图标grafana
* @author zhanglili
*/
var IconGrafana =
/*#__PURE__*/
createIcon('grafana', SVG$16);

var SVG$17 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M928 544v383H545V544h383zm-64 64H609v255h255V608zM481 97v830H98V97h383zm447 0v383H545V97h383zm-511 64H162v702h255V161zm447 0H609v255h255V161z"
  }));
});

/**
* @file 图标group
* @author zhanglili
*/
var IconGroup =
/*#__PURE__*/
createIcon('group', SVG$17);

var SVG$18 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M797.9 228.3l73.2 42.2-136 78.1c-10.3 5.9-23 5.9-33.2 0l-86-49.5-69.9-40.2c-20.8-12-46.4-12-67.2 0L390 310l-68.2 39.3c-10.3 5.9-23 5.9-33.3 0L153 270.9 458.2 95.3c2.4-1.4 4.9-2.6 7.4-3.8l48-27.6L798 228.2l-.1.1zm-21.2 189.5l135.7-78.1v413.5l-53.1 30.6-1.2.8-307.5 177V805.3c0-11.9 6.4-22.9 16.7-28.9l159.1-91.6c20.8-12 33.7-34.1 33.7-58.1v-180c0-12 6.3-23 16.6-28.9zM452.9 774c10.3 6 16.7 17 16.7 28.9v156.2L166.9 784.8c-2.3-1.3-4.5-2.7-6.7-4.2l-47.6-27.5V339.6l.1.3L248.2 418c10.3 6 16.7 17 16.7 28.9V627c0 24 12.8 46.1 33.6 58.1L452.9 774z"
  }));
});

/**
* @file 图标group-cloud
* @author zhanglili
*/
var IconGroupCloud =
/*#__PURE__*/
createIcon('group-cloud', SVG$18);

var SVG$19 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M518.9 170.7c123.7 0 231.5 81.3 265.2 199.3l2.8 10.5c1.1 2.6 1.1 5.3 1.1 7.9C897.9 408 982 504.1 981.4 618.8c0 126.3-100.1 229.5-225.2 234.4l-9.4.2H255.1c-117.3 0-212.5-95.1-212.5-212.4 0-113.1 89.3-205.5 200.8-211.9 9.1-143.8 129.1-258.4 275.5-258.4zm0 64c-108.6 0-199.2 82.6-210.7 188.9l-.8 9.4-3.5 56.7-56.7 3.2c-78.4 4.5-140.5 69.6-140.5 148 0 79.2 62.1 144 140.3 148.2l8.1.2h491.5c94.1 0 170.7-76.5 170.7-170.9.4-79.1-55.7-147.8-132.4-165.4l-8.3-1.7-52.8-9.4v-49.3l-1.7-6.5C696.8 299.6 619.3 239 528.6 234.9l-9.7-.2zM304.1 565.3v64h-47.2l2.6 4.9c13.7 23.2 35.7 36.6 67.4 41.6l8.1 1.1-6.9 63.6c-77.9-8.4-127.9-52.9-144.4-128.1l-1.9-9.6-6.6-37.6h128.9v.1zm158.5-131.1l52.8 129.6 62.3-120.1L614 615.9h68.7v64H562.1L552 632.1l-43.6 84.1-51.5-126.4L432 640h-90.7v-64h51l70.3-141.8zM712.7 480c80.4 8.7 127.1 61 135.5 148l.8 9.8 2.1 34H726.3v-64h53.9l-1.5-5.6c-10.1-34.1-31.4-52.1-65.8-57.7l-7.1-.9 6.9-63.6z"
  }));
});

/**
* @file 图标gtc
* @author zhanglili
*/
var IconGTC =
/*#__PURE__*/
createIcon('gtc', SVG$19);

var SVG$1a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M97 560.96h59.29c0 16.71-13.27 30.26-29.64 30.26S97 577.68 97 560.96zm770.71 0H927c0 16.71-13.27 30.26-29.64 30.26-16.38 0-29.65-13.54-29.65-30.26zM927 682.01h-59.29c0-16.71 13.27-30.26 29.64-30.26 16.37-.01 29.65 13.54 29.65 30.26zm-770.71 0H97c0-16.71 13.27-30.26 29.64-30.26s29.65 13.54 29.65 30.26zM188.96 186.25v121.04c0 14.32 11.61 25.94 25.94 25.94 14.32 0 25.94-11.61 25.94-25.94V186.25c0-14.32-11.61-25.94-25.94-25.94-14.33 0-25.94 11.62-25.94 25.94zM485.38 186.25v121.04c0 14.32 11.61 25.94 25.94 25.94 14.32 0 25.94-11.61 25.94-25.94V186.25c0-14.32-11.61-25.94-25.94-25.94-14.32 0-25.94 11.62-25.94 25.94zM781.81 186.25v121.04c0 14.32 11.61 25.94 25.94 25.94s25.94-11.61 25.94-25.94V186.25c0-14.32-11.61-25.94-25.94-25.94s-25.94 11.62-25.94 25.94z"
  }), React.createElement("path", {
    d: "M156.29 560.96H97V439.92c0-33.42 26.54-60.52 59.29-60.52h118.57c32.74 0 59.29 27.1 59.29 60.52v363.12c0 33.42-26.54 60.52-59.29 60.52H156.29c-32.74 0-59.29-27.1-59.29-60.52V682.01h59.29v121.04h118.57V439.92H156.29v121.04zM452.71 439.92v363.12h118.57V439.92H452.71zm0-60.52h118.57c32.74 0 59.29 27.1 59.29 60.52v363.12c0 33.42-26.54 60.52-59.29 60.52H452.71c-32.74 0-59.29-27.1-59.29-60.52V439.92c.01-33.42 26.55-60.52 59.29-60.52zM867.71 682.01H927v121.04c0 33.42-26.54 60.52-59.29 60.52H749.14c-32.74 0-59.29-27.1-59.29-60.52V439.92c0-33.42 26.54-60.52 59.29-60.52h118.57c32.74 0 59.29 27.1 59.29 60.52v121.04h-59.29V439.92H749.14v363.12h118.57V682.01z"
  }), React.createElement("path", {
    d: "M334.14 647.42h59.29v-51.87h-59.29zM630.57 647.42h59.29v-51.87h-59.29z"
  }));
});

/**
* @file 图标hadoop
* @author zhanglili
*/
var IconHadoop =
/*#__PURE__*/
createIcon('hadoop', SVG$1a);

var SVG$1b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M556.5 943.2c-46.3 0-83.7-36.9-83.7-82.5s37.5-82.5 83.7-82.5c29.2 0 56.2 15.2 71.6 39.6l4.4 7.1 8.3-2.2c50.1-14.7 95.9-42.9 131.7-80.9l9.4-9.8-12.1-7.1c-40.2-22.3-63.9-63-63.9-108.6v-57.5c0-60.3 44.1-112.4 104.7-123.8l10.5-1.6-1.7-10.3c-20.4-152-146-266.6-292-266.6h-29.2c-145.4 0-271 114.5-292 266.6l-1.7 10.3L215 435c60.6 10.9 104.1 63 104.7 123.8v57.5c0 69.5-57.3 125.9-127.8 125.9S64 685.8 64 616.4v-57.5c0-40.2 20.4-78.7 54.5-102.6l4.4-3.3v-5.4c4.4-97.7 44.1-189.5 111.8-259C305.3 116.4 399 76.7 497.6 76.7h29.2c99.2 0 192.3 39.6 262.8 111.8 67.8 68.9 107.4 160.7 111.8 259v5.4l4.4 3.3c34.2 23.9 54.5 61.9 54.5 102.1v57.5c0 50.5-30.9 96.1-78.2 115.6l-3.3 1.1-1.7 3.3c-54.5 88.5-145.4 150.9-248.5 171l-3.9.5-2.8 3.3c-14.7 20.1-39.5 32.6-65.4 32.6zM198.5 503c-24.4 0-44.8 18.8-44.8 41.4V611c0 22.6 20.4 41.4 44.8 41.4s44.8-18.8 44.8-41.4v-66.5c0-23.3-20.4-41.5-44.8-41.5zm627.4 0c-24.4 0-44.8 18.8-44.8 41.4V611c0 22.6 20.4 41.4 44.8 41.4s44.8-18.8 44.8-41.4v-66.5c0-23.3-20.3-41.5-44.8-41.5z"
  }));
});

/**
* @file 图标headphone
* @author zhanglili
*/
var IconHeadphone =
/*#__PURE__*/
createIcon('headphone', SVG$1b);

var SVG$1c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M10 1.75A8.25 8.25 0 1 1 1.75 10 8.25 8.25 0 0 1 10 1.75zm0 1.5A6.75 6.75 0 1 0 16.75 10 6.75 6.75 0 0 0 10 3.25zM11 13v1.5H9.5V13zm-1-7.7a2.75 2.75 0 0 1 1 5.31v1.7H9.5v-1.99a1 1 0 0 1 .83-1A1.36 1.36 0 0 0 11.38 8a1.38 1.38 0 0 0-2.76 0H7.25A2.75 2.75 0 0 1 10 5.25z"
  }))));
});

/**
* @file 图标help
* @author zhanglili
*/
var IconHelp =
/*#__PURE__*/
createIcon('help', SVG$1c);

var SVG$1d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M512 64c247.42 0 448 200.58 448 448S759.42 960 512 960 64 759.42 64 512 264.58 64 512 64zm0 64c-212.08 0-384 171.92-384 384s171.92 384 384 384 384-171.92 384-384-171.92-384-384-384zm32 225v448h-64V353zm0-129v64h-64v-64z",
    "data-name": "\u8B66\u544A\u63D0\u793A/\u63D0\u793A"
  }))));
});

/**
* @file 图标help-link
* @author zhanglili
*/
var IconHelpLink =
/*#__PURE__*/
createIcon('help-link', SVG$1d);

var SVG$1e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7.5",
    fill: "#FFF",
    stroke: "#999"
  }), React.createElement("path", {
    d: "M7 3h2v2H7zm0 3h2v7H7z"
  })));
});

/**
* @file 图标hint
* @author zhanglili
*/
var IconHint =
/*#__PURE__*/
createIcon('hint', SVG$1e);

var SVG$1f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M10.011 1.753l8.084 5.227-.814 1.26-.532-.344.001 9.854H3.25V7.811l-.575.364-.803-1.267 8.14-5.155zm-.009 1.781L4.749 6.86l.001 9.389h10.5V6.926l-5.248-3.392z"
  }));
});

/**
* @file 图标home
* @author zhanglili
*/
var IconHome =
/*#__PURE__*/
createIcon('home', SVG$1f);

var SVG$1g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M14.305 6.5l-2.015 6H4.733l-2.035-6h11.607z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 14h7v1H5zM2 7h1l.197 1H2zm-1 3h3l.49 1H1.75z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M8.51 1v2L7.505 4.027v1.476M10.51 2v1L9.505 4.027v.99"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 7v3H1V8z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标icafe
* @author zhanglili
*/
var IconICafe =
/*#__PURE__*/
createIcon('icafe', SVG$1g);

var SVG$1h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 192 192"
  }, props), React.createElement("path", {
    d: "M162.39 58C153.84 29.29 126.93 8.32 96 8.32A69.14 69.14 0 0 0 29.62 58 69.25 69.25 0 0 0 70.7 183a68.68 68.68 0 0 0 25.3-4.8 69.23 69.23 0 0 0 94.56-64.45A69.56 69.56 0 0 0 162.39 58zM96 21.49a56.4 56.4 0 0 1 55.85 51.14c.16 1.79.23 3.4.23 4.94a57 57 0 0 1-17.36 40.65l-32.85-64.75c0-.07-.08-.11-.11-.17a7.18 7.18 0 0 0-.9-1.3 6.88 6.88 0 0 0-1.25-1l-.39-.22a5.54 5.54 0 0 0-.53-.3 69.17 69.17 0 0 0-50.45-2.14A56 56 0 0 1 96 21.49zm0 74.28a6.59 6.59 0 0 0-6.59 6.59v12.87l-17.85 4L96 71l24.44 48.18-17.85-4v-12.82A6.59 6.59 0 0 0 96 95.77zm-81.39 18a56.33 56.33 0 0 1 22.88-45.18 55.72 55.72 0 0 1 49.28-8.5l-33.26 65.58a1.29 1.29 0 0 0-.07.21 6.62 6.62 0 0 0-.5 1.46.5.5 0 0 0 0 .13 6.78 6.78 0 0 0-.08 1.63c0 .15 0 .3.06.45s0 .39.08.59c3.59 15.41 13.13 29.22 26.47 39a55.34 55.34 0 0 1-8.74.76 56.15 56.15 0 0 1-56.12-56.12zm106.69 56.09a55.66 55.66 0 0 1-22.64-4.78c-14.54-6.43-25.7-18-30.9-31.55L96 127.26l35.19 7.82a6.88 6.88 0 0 0 1.43.15 6.51 6.51 0 0 0 1.32-.15l.33-.08a6 6 0 0 0 1.08-.38l.19-.08a5.8 5.8 0 0 0 1-.59l.21-.16A70.39 70.39 0 0 0 165.21 79a56 56 0 0 1-43.91 90.89z"
  }));
});

/**
* @file 图标icloud
* @author zhanglili
*/
var IconICloud =
/*#__PURE__*/
createIcon('icloud', SVG$1h);

var SVG$1i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "124",
    height: "23"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M86.768 12.8v-1.104h-8.616V12.8h8.616zm-.288 9.444l1.02-.708c-.6-1.2-1.44-2.616-2.532-4.236l-.912.564c.456.72.876 1.428 1.26 2.112-1.944.276-3.912.48-5.88.6.78-.888 1.68-2.364 2.712-4.428h5.688v-1.14H77v1.14h3.876c-1.188 2.376-2.148 3.84-2.88 4.392-.06.036-.156.072-.276.108l.3 1.164c2.832-.192 5.448-.456 7.86-.792.216.408.408.816.6 1.224zm13.308-.516v-1.104h-5.364V15.8h4.44v-1.104h-4.44v-3.612h-1.176v9.54h-4.212v1.104h10.752zm3.612.42v-.432h6.084v.432h1.152v-7.932h-4.176a13.33 13.33 0 0 0 .336-1.62h5.052V11.48h-10.872v1.116h4.692c-.072.552-.18 1.092-.324 1.62h-3.108v7.932h1.164zm6.084-4.74H103.4v-2.1h6.084v2.1zm0 3.192H103.4v-2.148h6.084V20.6zm4.2 1.524c.816-1.584 1.236-3.672 1.284-6.288v-.672h1.8v1.848h5.028v-1.848h1.8v-1.056h-1.8v-.816h-1.104v.816h-2.82v-.804h-1.104v.804h-1.8v-1.104h8.628v-1.08h-4.032a9.777 9.777 0 0 0-.384-.924l-1.212.192c.144.216.288.468.42.732h-4.548v3.912c-.024 2.352-.372 4.2-1.02 5.52l.864.768zm7.008-6.06h-2.82v-.9h2.82v.9zm2.724 6.168l.492-.984c-1.32-.168-2.496-.456-3.516-.84a8.667 8.667 0 0 0 2.208-1.896v-.84h-7.104v.972h.804c.504.648 1.128 1.212 1.884 1.716-1.032.396-2.22.684-3.552.876l.492.996c1.584-.264 2.988-.672 4.188-1.236 1.14.552 2.508.972 4.104 1.236zm-4.188-2.34a7.352 7.352 0 0 1-1.704-1.248h3.54a8.968 8.968 0 0 1-1.836 1.248zM41.478 13.789c-.516-.488-1.947-1.454-3.034-3.254-.731-1.19-1.977-1.994-3.295-1.968-1.319-.026-2.565.778-3.296 1.968-1.087 1.8-2.518 2.766-3.034 3.254-.645.61-3.378 2.06-2.783 5.232.587 3.13 3.552 3.27 3.552 3.27s1.386.147 3.774-.43a8.584 8.584 0 0 1 1.787-.198 8.582 8.582 0 0 1 1.786.199c2.388.576 3.775.428 3.775.428s2.964-.14 3.551-3.27c.596-3.17-2.137-4.621-2.783-5.231m-13.734-1.848c1.627-.223 2.193-1.881 2.027-3.474-.148-1.408-1.094-3.012-2.65-2.872-1.497.136-2.421 1.608-2.412 3.338.009 1.646 1.151 3.267 3.035 3.008"
  }), React.createElement("path", {
    d: "M3.108 6.572c1.607-.153 2.179-1.802 2.14-3.422-.04-1.784-1.019-3.215-2.56-3.132C1.316.09.209 1.468.153 3.3.094 5.214 1.321 6.74 3.108 6.572",
    mask: "url(#b)",
    transform: "translate(29.17 .24)"
  }), React.createElement("path", {
    d: "M42.553 11.941c-1.626-.223-2.193-1.881-2.026-3.474.147-1.408 1.093-3.012 2.65-2.872 1.496.136 2.421 1.608 2.411 3.338-.009 1.646-1.15 3.267-3.035 3.008"
  }), React.createElement("path", {
    d: "M2.255 6.572C.647 6.419.075 4.77.113 3.15.155 1.366 1.133-.065 2.676.018 4.046.09 5.153 1.468 5.209 3.3c.06 1.914-1.168 3.441-2.954 3.272",
    mask: "url(#d)",
    transform: "translate(35.765 .24)"
  }), React.createElement("path", {
    d: "M33.827 18.785h-2.3c-.782 0-1.281-.624-1.281-1.326 0-.7.47-1.33 1.242-1.33h2.25v-1.492h-2.24c-1.665 0-2.79 1.22-2.79 2.77 0 1.691 1.056 2.877 2.893 2.877h2.226v-1.5zm1.725-4.195h1.499v3.49c0 .548.218.708.503.708h1.551l-.001-4.199h1.505v5.696h-3.178c-1.292 0-1.879-.696-1.879-1.72V14.59z"
  }), React.createElement("path", {
    d: "M34.365 20.284v-8.047h-1.549l-.002 8.047zM20.82 12.318h2.446v-2.13H20.82v2.13zm0 9.309h2.446v-8.379H20.82v8.379zm-3.977-8.385h-5.219v1.76h4.578c.66 0 1.088.354 1.088.95v.62h-3.824c-1.47 0-2.498.887-2.498 2.528 0 1.76 1.047 2.554 2.498 2.554h6.18V15.65c0-1.438-1.143-2.41-2.803-2.41zm.447 6.754h-3.234c-.447 0-.797-.317-.797-.896 0-.498.349-.9.847-.9h3.184v1.796zm-6.91-1.312c0-1.381-.681-2.42-1.767-2.744.965-.412 1.369-1.233 1.369-2.56 0-1.736-1.448-3.268-4.402-3.268H0V21.75h6.17c2.756 0 4.21-1.067 4.21-3.065m-4.35.908H2.56v-2.51h3.453c.903 0 1.526.472 1.526 1.278 0 .807-.609 1.232-1.509 1.232m-.143-4.794H2.56v-2.416h3.318c.935 0 1.488.439 1.488 1.142 0 .938-.554 1.274-1.48 1.274m52.227-2.644V10.41H46.519v1.763h4.397l-.381 1.157H47.03v8.372h8.996c.927 0 1.54-.538 1.54-1.503V13.33h-4.654l.381-1.176h4.82zm-2.581 7.322c0 .334-.18.525-.46.525H49.13v-1.746h6.401v1.22zm-6.401-2.869h6.39v-1.622h-6.39v1.622zm18.803-1.996c0 .17-.138.308-.309.308h-3.288v-.822h3.597v.514zm1.747-2.364h-1.747v.411h-3.597v-.411H62.59v.411h-1.028v1.439h1.028v2.26h6.269a.822.822 0 0 0 .822-.821v-1.44h1.028V12.66H69.68v-.411z"
  }), React.createElement("path", {
    d: "M66.495 10.398v-.617H64.44v.617h-5.036v8.529c0 1.59-.252 2.396-.438 2.776h1.858c.192-.664.327-1.562.327-2.775v-7.091h9.558v-1.439h-4.214z"
  }), React.createElement("path", {
    d: "M66.084 19.226s-1.452-.65-2.012-.957h4.023c-.559.307-2.011.957-2.011.957m1.686.73c1.159-.62 2.527-1.397 2.527-1.397v-1.584H61.87v1.584s1.369.777 2.528 1.397c-.525.198-.946.319-1.175.319h-1.764v1.428h1.948c.21 0 .783 0 2.676-.894h.001c1.894.894 2.466.894 2.676.894h1.949v-1.428h-1.764c-.23 0-.65-.121-1.175-.32"
  })));
});

/**
* @file 图标icloud-logo
* @author zhanglili
*/
var IconIcloudLogo =
/*#__PURE__*/
createIcon('icloud-logo', SVG$1i);

var SVG$1j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M157.401 157.313v711.299H868.7V157.313H157.401zM98.126 98.038h829.849v829.849H98.126V98.038z"
  }), React.createElement("path", {
    d: "M157.401 157.313v118.55H868.7v-118.55H157.401zM98.126 98.038h829.849v237.1H98.126v-237.1zm218.685 482.617l93.766-107.484-44.667-38.966-130.819 149.957 132.571 127.951 41.164-42.651zM590.74 473.171l44.667-38.966 130.82 149.957-132.571 127.951-41.164-42.651 92.015-88.807zM453.776 690.427h118.55v59.275h-118.55z"
  }));
});

/**
* @file 图标icode
* @author zhanglili
*/
var IconICode =
/*#__PURE__*/
createIcon('icode', SVG$1j);

var SVG$1k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("g", {
    "data-name": "2021\u5E74Q3\u6536\u5165"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M374.08 79c27.68 0 54.53 1.34 80.11 3.85l21.61 2.44 20.92 3c113.08 17.93 192.43 59.92 192.43 108.86a44 44 0 0 1-.35 5.63v231.45l-.9.08q10.36-.84 21-.85c141.38 0 256 114.62 256 256s-114.62 256-256 256a254.85 254.85 0 0 1-151.07-49.3l.63.46a626.18 626.18 0 0 1-459.66-36q-16.31-10.23-23.26-16.09-6.22-5.24-16.29-17.18v-626c-.12-1.39-.19-2.78-.19-4.19 0-48.94 79.35-90.93 192.43-108.86l20.93-3L294 82.85c25.54-2.51 52.39-3.85 80.08-3.85zm334.77 413.54c-108.76 0-196.93 88.16-196.93 196.92s88.17 196.92 196.93 196.92 196.92-88.16 196.92-196.92-88.17-196.92-196.92-196.92zM118.27 672.81v128.3C240.19 864.64 375.8 881 504.92 850.2l3.91-1-.76-1a254.78 254.78 0 0 1-53-125l-.19-1.45v.32a626.2 626.2 0 0 1-336.61-49.26zm580.34-121.19l41.78 41.77-61.3 61.17H849.7v53.58H681.8l63.2 62.62-41.77 41.77L571 679l40.34-40.61.18.18zm-580.34-95.43v151.2a567.12 567.12 0 0 0 332.56 55.76l3.4-.48-.08.84.21-2.06a255.75 255.75 0 0 1 100.52-176.53l1.7-1.28-4.28 1.29a626.23 626.23 0 0 1-434.03-28.74zm511.63-190c-33.58 17.48-79.59 31.38-133.18 39.88l-20.92 3-21.61 2.44c-25.58 2.52-52.43 3.86-80.11 3.86S319.54 314 294 311.45L272.36 309l-20.93-3c-53.57-8.5-99.58-22.39-133.16-39.87v124.65a567.12 567.12 0 0 0 511.59 0zM374.08 138.08c-78 0-150.44 11.49-202 30.84-22.45 8.42-39.28 17.76-49.08 26.45l-2 1.78 2 1.79c9.8 8.69 26.63 18 49.08 26.45 51.61 19.35 124 30.84 202 30.84s150.43-11.49 202.05-30.84c22.45-8.42 39.27-17.76 49.07-26.45l2-1.79-2-1.78c-9.8-8.69-26.62-18-49.07-26.45-51.62-19.35-124.06-30.84-202.05-30.84z"
  })))));
});

/**
* @file 图标income
* @author zhanglili
*/
var IconIncome =
/*#__PURE__*/
createIcon('income', SVG$1k);

var SVG$1l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M8 1.4l6.47 4.18-.66 1-.42-.27v7.89H2.6V6.25l-.46.29-.64-1zm0 1.43L3.8 5.49V13h8.4V5.54z"
  }))));
});

/**
* @file 图标index-page
* @author zhanglili
*/
var IconIndexPage =
/*#__PURE__*/
createIcon('index-page', SVG$1l);

var SVG$1m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M97 95.87h829.99v831.77H97V95.87zm59.29 59.41v712.95h711.42V155.28H156.29z"
  }), React.createElement("path", {
    d: "M482.36 274.11h59.28v356.47h-59.28V274.11z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M482.36 689.99h59.28v59.41h-59.28z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标info-mark
* @author zhanglili
*/
var IconInfoMark =
/*#__PURE__*/
createIcon('info-mark', SVG$1m);

var SVG$1n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    d: "M15 9l-1 6H2L1 9zm-1.18 1H2.18l.67 4h10.3zM10 11v1H9v-1zm2 0v1h-1v-1zM8 5a3 3 0 0 1 2.52 1.38l-.73.73a2 2 0 0 0-3.58 0l-.73-.73A3 3 0 0 1 8 5zm0-2a5 5 0 0 1 4 1.94l-.72.72a4 4 0 0 0-6.48 0L4 4.94A5 5 0 0 1 8 3zm0-2a7 7 0 0 1 5.38 2.52l-.71.71a6 6 0 0 0-9.34 0l-.71-.71A7 7 0 0 1 8 1z"
  }))));
});

/**
* @file 图标ip
* @author zhanglili
*/
var IconIP =
/*#__PURE__*/
createIcon('ip', SVG$1n);

var SVG$1o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 0v5H7v4h5V8h4v8h-4v-1H1V5H0V0h8zm7 9h-2v6h2V9zM6 5H2v9h10v-4H6V5zm1-4H1v3h6V1z"
  }));
});

/**
* @file 图标ipipe
* @author zhanglili
*/
var IconIpipe =
/*#__PURE__*/
createIcon('ipipe', SVG$1o);

var SVG$1p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M7.5.2l7 4.08L8 8.06v7.59l-7-4.08V4zm7.25 5.16v6.73L9.27 15.3l-.27.15v-1.16l4.75-2.77V6zm-7.25-4L2 4.56V11l5 2.92V7.49l5.51-3.21zm5.25 8v1.15L9 12.73v-1.16zm0-2.43v1.18L9 10.3V9.14z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标iregistry
* @author zhanglili
*/
var IconIregistry =
/*#__PURE__*/
createIcon('iregistry', SVG$1p);

var SVG$1q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M11 14v1H5v-1zM10 2v1H2v9h12V7h1v6H1V2zm5 0v3h-1V3.7L9.84 7.83 8.06 6.64 5 9.74A1.09 1.09 0 0 1 5 10a1 1 0 1 1-1-1 1.09 1.09 0 0 1 .26 0l3.68-3.65 1.77 1.19L13.29 3H12V2z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标ireport
* @author zhanglili
*/
var IconIReport =
/*#__PURE__*/
createIcon('ireport', SVG$1q);

var SVG$1r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M128.025 63.868h767.734v895.69H128.025V63.868zm63.978 63.978V895.58h639.778V127.846H192.003z"
  }), React.createElement("path", {
    d: "M255.981 255.802h511.823v63.978H255.981v-63.978zm479.833 31.989l-31.989 31.989v-63.978l31.989 31.989zM255.981 511.713h511.823v63.978H255.981v-63.978zm479.833 31.989l-31.989 31.989v-63.978l31.989 31.989zM255.981 703.647h511.823v63.978H255.981v-63.978zm479.833 31.989l-31.989 31.989v-63.978l31.989 31.989z"
  }), React.createElement("path", {
    stroke: "#000",
    d: "M351.947 223.813h63.978v127.956h-63.978z"
  }), React.createElement("path", {
    d: "M319.958 703.647h127.956v127.956H319.958zm319.89-255.912h63.978v191.934h-63.978V447.735zm31.988 31.989l31.989 31.989h-63.978l31.989-31.989z"
  }));
});

/**
* @file 图标kong-ming
* @author zhanglili
*/
var IconKongMing =
/*#__PURE__*/
createIcon('kong-ming', SVG$1r);

var SVG$1s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h1024v1024H0z"
  }), React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M522.415 0c83.997 0 152.09 68.093 152.09 152.09s-68.093 152.09-152.09 152.09-152.09-68.093-152.09-152.09S438.418 0 522.415 0zm0 71.7c-44.398 0-80.39 35.992-80.39 80.39s35.992 80.39 80.39 80.39 80.39-35.992 80.39-80.39-35.992-80.39-80.39-80.39z"
  }), React.createElement("path", {
    d: "M231.27 715.617L420.138 834.29v84.68L231.27 800.295v-84.679zm560.612-10.138v87.44L632.137 904.425v-87.44L791.882 705.48zM425.729 206.36v45.675h55.309L231.27 573.154V527.97h-55.686l250.145-321.61zm196.63 4.944L855.79 527.97h-63.907v34.14L563.31 252.033h59.05v-40.73zm-61.565 57.026v489.947h-73.142V268.33z"
  }), React.createElement("path", {
    d: "M231.271 527.97v301.572H14V527.97h217.271zm-71.7 71.699H85.7v158.174h73.872V599.669zm473.322 122.758V1024H415.62V722.427h217.272zm-71.7 71.7h-73.872V952.3h73.872V794.127zm447.96-266.157v301.572H791.882V527.97h217.271zm-71.7 71.699h-73.872v158.174h73.872V599.669z"
  }))));
});

/**
* @file 图标lb
* @author zhanglili
*/
var IconLb =
/*#__PURE__*/
createIcon('lb', SVG$1s);

var SVG$1t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M381.6 511l379.7-341.6c2.2-2 3.5-4.8 3.5-7.7V73c0-8.8-10.4-13.6-17.1-7.7L258.8 502.6c-4.7 4.1-4.7 11.4 0 15.5l488.9 438.3c6.6 5.8 17.1 1.1 17.1-7.7v-87.6c0-3-1.3-5.8-3.5-7.7L381.6 511z"
  }));
});

/**
* @file 图标left
* @author zhanglili
*/
var IconLeft =
/*#__PURE__*/
createIcon('left', SVG$1t);

var SVG$1u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("path", {
    d: "M12.52 10.708a5.042 5.042 0 0 1 5.042 5.042v3.667H1.52V15.75a5.042 5.042 0 0 1 5.042-5.042h5.958zm0 1.93H6.562a3.112 3.112 0 0 0-3.107 2.935l-.005.177-.001 1.736h12.182V15.75a3.112 3.112 0 0 0-2.934-3.107l-.177-.005zm7.792-1.013v1.833H18.02v-1.833h2.292zM9.54 2a3.896 3.896 0 1 1 0 7.792A3.896 3.896 0 0 1 9.54 2zm10.77 5.958v1.834h-4.583V7.958h4.584zM9.542 3.93a1.966 1.966 0 1 0 0 3.932 1.966 1.966 0 0 0 0-3.932z"
  }));
});

/**
* @file 图标mail-list
* @author zhanglili
*/
var IconMailList =
/*#__PURE__*/
createIcon('mail-list', SVG$1u);

var SVG$1v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M159.8 129v128.1h64.1V129zm320.5 0v128.1h64.1V129zm320.4 0v128.1h64.1V129zm-737 192.2h64.1v256.4H63.7z"
  }), React.createElement("path", {
    d: "M63.7 321.2h256.4v64.1H63.7z"
  }), React.createElement("path", {
    d: "M256 321.2h64.1V898H256zm128.1 0h64.1V898h-64.1z"
  }), React.createElement("path", {
    d: "M384.1 834h256.4v64.1H384.1V834zm320.5-448.7h64.1V898h-64.1V385.3zm0-64.1H961v64.1H704.6v-64.1zm192.3 64.1H961v192.3h-64.1V385.3zM768.7 834h128.2v64.1H768.7V834z"
  }), React.createElement("path", {
    d: "M896.9 641.7H961v256.4h-64.1V641.7zM576.4 321.2h64.1V898h-64.1z"
  }), React.createElement("path", {
    d: "M384.1 321.2h256.4v64.1H384.1v-64.1zM63.7 834H256v64.1H63.7z"
  }), React.createElement("path", {
    d: "M63.7 641.7h64.1v256.4H63.7zM256 577.6h192.3v64.1H256v-64.1zm320.4 0h192.3v64.1H576.4v-64.1zm160.3 32.1l-32 32v-64.1l32 32.1z"
  }));
});

/**
* @file 图标map-reduce
* @author zhanglili
*/
var IconMapReduce =
/*#__PURE__*/
createIcon('map-reduce', SVG$1v);

var SVG$1w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M97.624 98.228h829.768v829.768H97.624V98.228zm59.269 59.269v711.23h711.23v-711.23h-711.23z"
  }), React.createElement("path", {
    d: "M808.854 216.891H216.162v59.27h592.692zm-177.808 414.23V455.195h177.808V276.161h-59.27v119.765H571.777V690.39h237.077v-59.269z"
  }), React.createElement("path", {
    d: "M631.046 631.65h177.808v59.269H631.046zM216.162 809.712h592.692v-59.269H216.162zM393.97 394.573v177.18H216.162v178.69h59.269V631.022h177.808V335.304H216.162v59.269z"
  }), React.createElement("path", {
    d: "M216.162 335.304H393.97v59.269H216.162v-59.269z"
  }));
});

/**
* @file 图标matrix
* @author zhanglili
*/
var IconMatrix =
/*#__PURE__*/
createIcon('matrix', SVG$1w);

var SVG$1x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "menu-fold",
    viewBox: "64 64 896 896"
  }, props), React.createElement("path", {
    d: "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z"
  }));
});

/**
* @file 图标menu-fold-outline
* @author zhanglili
*/
var IconMenuFoldOutline =
/*#__PURE__*/
createIcon('menu-fold-outline', SVG$1x);

var SVG$1y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "menu-unfold",
    viewBox: "64 64 896 896"
  }, props), React.createElement("path", {
    d: "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
  }));
});

/**
* @file 图标menu-unfold-outline
* @author zhanglili
*/
var IconMenuUnfoldOutline =
/*#__PURE__*/
createIcon('menu-unfold-outline', SVG$1y);

var SVG$1z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M14 1v14H2V1zm-1 1H3v12h10zM6 4v1h1V4h2v1h1V4h2v2h-.75v1H12v2h-.75v1H12v2h-2v-.5H9v.5H7v-.5H6v.5H4v-2h.75V9H4V7h.75V6H4V4zm1 4.5H6V9h-.75v1H6v1h1v-1h.75V9H7zm1.4.5h-.15v1H9v1h1v-.4zm1.6-.5H9v.4l1.1 1.1h.65V9H10zM5.4 6h-.15v1H6v1h1v-.4zm4.6-.5H9V6h-.75v1H9v1h1V7h.75V6H10zm-3 0H6v.4L7.1 7h.65V6H7z"
  }))));
});

/**
* @file 图标mesh
* @author zhanglili
*/
var IconMesh =
/*#__PURE__*/
createIcon('mesh', SVG$1z);

var SVG$1A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "22",
    height: "22"
  }, props), React.createElement("path", {
    d: "M11 2a3.5 3.5 0 0 1 3.008 5.29l3.361 5.819A3.501 3.501 0 0 1 16.5 20a3.502 3.502 0 0 1-3.362-2.523H8.862A3.502 3.502 0 0 1 2 16.5a3.5 3.5 0 0 1 2.971-3.46l3.18-5.507A3.5 3.5 0 0 1 11 2zM5.5 14.8a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4zm11 0a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4zM11 9c-.513 0-1-.11-1.44-.309l-2.656 4.602a3.507 3.507 0 0 1 1.998 2.383h4.196a3.507 3.507 0 0 1 2.242-2.48l-2.668-4.62A3.484 3.484 0 0 1 11 9zm0-5.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4z"
  }));
});

/**
* @file 图标min-alb
* @author zhanglili
*/
var IconMinALB =
/*#__PURE__*/
createIcon('min-alb', SVG$1A);

var SVG$1B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M819.2 102.4v819.2H204.8V102.4h614.4zm-76.8 76.8H281.6v665.6h460.8V179.2zm-153.6 512V768H435.2v-76.8h153.6z"
  }));
});

/**
* @file 图标mobile
* @author zhanglili
*/
var IconMobile =
/*#__PURE__*/
createIcon('mobile', SVG$1B);

var SVG$1C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M128.014 63.223h636.251l132.909 168.254v729.099h-769.16V63.223zm64.097 64.097v769.16h640.966V253.739L733.215 127.32H192.111z"
  }), React.createElement("path", {
    d: "M256.208 63.223h448.677v192.29H256.208V63.223zm64.096 64.097v64.097h320.483V127.32H320.304zm-64.096 256.386h128.193v64.097H256.208zm0 64.097h64.096V704.19h-64.096z"
  }), React.createElement("path", {
    d: "M320.304 255.513h64.097v192.29h-64.097zm-64.096 512.773h512.773v64.097H256.208zm0-128.193h128.193v64.097H256.208zM448.497 319.61h64.097v256.387h-64.097V319.61zm256.387 0h64.097v256.387h-64.097V319.61z"
  }), React.createElement("path", {
    d: "M513.078 320.259h-64.581v64.097h26.652l105.4 191.959h62.716l101.128-191.959h24.588v-64.097h-63.268l-94.325 179.046zm-64.581 319.834h320.484v64.097H448.497z"
  }));
});

/**
* @file 图标mola-db
* @author zhanglili
*/
var IconMolaDB =
/*#__PURE__*/
createIcon('mola-db', SVG$1C);

var SVG$1D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M773.707 834.683c101.544 0 183.862-82.318 183.862-183.862s-82.318-183.862-183.862-183.862-183.862 82.318-183.862 183.862 82.318 183.862 183.862 183.862zm0-61.287c-67.696 0-122.575-54.878-122.575-122.575s54.878-122.574 122.575-122.574 122.574 54.878 122.574 122.574-54.878 122.575-122.574 122.575z"
  }), React.createElement("path", {
    d: "M773.707 712.108c33.848 0 61.287-27.439 61.287-61.287s-27.439-61.287-61.287-61.287-61.287 27.439-61.287 61.287 27.439 61.287 61.287 61.287zM743.063 804.039v153.218h61.287V804.039z"
  }), React.createElement("path", {
    d: "M896.281 895.97h-244.57v61.287h244.57zm0-796.734h61.287v367.723h-61.287zm-735.447 0h735.447v61.287H160.834zm-61.287 0h61.287V895.97H99.547zm61.287 735.447H467.27v61.287H160.834zm61.287-612.873h612.873v61.288H222.121zm0 122.575h429.011v61.287H222.121zm0 122.574h61.287v306.436h-61.287V466.959zm30.644 30.644l30.644 30.644h-61.287l30.643-30.644zm214.505-30.644h61.287v306.436H467.27V466.959zm30.644 30.644l30.644 30.644H467.27l30.644-30.644z"
  }), React.createElement("path", {
    d: "M377.842 690.555l-91.56-222.975h-64.161v61.287h23.074l100.78 245.428h64.747l96.696-245.428h21.14V467.58h-62.866z"
  }));
});

/**
* @file 图标monitor
* @author zhanglili
*/
var IconMonitor =
/*#__PURE__*/
createIcon('monitor', SVG$1D);

var SVG$1E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M17.648 9.633a4.852 4.852 0 0 1 .915 9.617l-.001 1.421h2.086V22.5h-5.985v-1.828l2.071-.001V19.25a4.854 4.854 0 0 1-3.932-4.55l-.005-.216a4.852 4.852 0 0 1 4.851-4.851zM22.5 3v6h-1.828l-.001-4.172H3.328v14.015H12v1.829H1.5V3h21zm-4.852 8.46a3.023 3.023 0 1 0 0 6.048 3.023 3.023 0 0 0 0-6.047zm0 1.548a1.477 1.477 0 1 1 0 2.953 1.477 1.477 0 0 1 0-2.953zM12 10.313v1.828H5.156v-1.829H12zm6.844-3.657v1.828H5.156V6.656h13.688z"
  }));
});

/**
* @file 图标monitoring
* @author zhanglili
*/
var IconMonitoring =
/*#__PURE__*/
createIcon('monitoring', SVG$1E);

var SVG$1F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M15.02 16.855v1.25H4.96v-1.25h10.06zm3.085-14.96v13.164H1.895V1.895h16.21zm-1.25 1.249H3.144v10.664h13.711V3.144zM7.102 4.535c.307 0 .565.06.772.182.147.088.27.178.366.27l.104.112.092.117.091.134a1.2 1.2 0 0 1 .095.19l.055.17.045.242.033.368.01.325-.014.71-.006.084a1.547 1.547 0 0 1-.04.248l-.042.126a.894.894 0 0 1-.133.212l-.163.15-.23.155-.03.017.208.146.118.1.043.043c.057.06.104.125.142.196l.055.122.005.012c.03.09.05.187.063.291l.016.25.008.416-.008.66-.035.43-.024.149a1.492 1.492 0 0 1-.052.196l-.04.102-.057.109-.09.145c-.14.2-.317.367-.53.5-.222.138-.51.204-.86.204-.178 0-.366-.03-.563-.088a1.548 1.548 0 0 1-.544-.286 1.479 1.479 0 0 1-.316-.358l-.095-.169a1.594 1.594 0 0 1-.15-.587l-.006-.173v-.669h1.17v.617c.002.16.049.29.139.393a.474.474 0 0 0 .376.157c.16 0 .285-.053.376-.157a.571.571 0 0 0 .134-.318l.006-.102V9.55c-.002-.25-.044-.412-.117-.506l-.04-.04a.43.43 0 0 0-.156-.087l-.11-.022-.22-.017-.24-.01V7.849l.38-.027.016-.002a.806.806 0 0 0 .31-.093c.097-.06.156-.186.172-.4l.005-.115V6.195a.5.5 0 0 0-.139-.355.5.5 0 0 0-.377-.142c-.151 0-.263.037-.34.107l-.053.06a.701.701 0 0 0-.115.258l-.008.077v.665h-1.17V6.17a1.618 1.618 0 0 1 .5-1.153c.156-.146.337-.263.543-.351.207-.088.429-.132.665-.132zm5.818 0a1.8 1.8 0 0 1 .636.115 1.602 1.602 0 0 1 .91.864c.07.153.112.32.13.504l.01.189v4.554a1.684 1.684 0 0 1-.14.678 1.602 1.602 0 0 1-.91.864 1.783 1.783 0 0 1-.636.115c-.221 0-.434-.038-.637-.115a1.602 1.602 0 0 1-.91-.864 1.594 1.594 0 0 1-.13-.504l-.009-.189V6.192a1.648 1.648 0 0 1 .51-1.206c.157-.147.336-.259.54-.336.202-.076.415-.115.636-.115zm-2.357 6.68v1.164H9.379v-1.164h1.184zm2.347-5.438a.418.418 0 0 0-.296.1.277.277 0 0 0-.092.154l-.006.063v4.723c0 .092.031.16.098.221a.418.418 0 0 0 .296.099c.13 0 .224-.034.296-.099a.277.277 0 0 0 .092-.155l.007-.063V6.097a.281.281 0 0 0-.099-.22.418.418 0 0 0-.296-.1z"
  }));
});

/**
* @file 图标monitoring-three
* @author zhanglili
*/
var IconMonitoringThree =
/*#__PURE__*/
createIcon('monitoring-three', SVG$1F);

var SVG$1G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 8.75A1.25 1.25 0 1 1 3.75 10 1.25 1.25 0 0 1 5 8.75zm5 0A1.25 1.25 0 1 1 8.75 10 1.25 1.25 0 0 1 10 8.75zm5 0A1.25 1.25 0 1 1 13.75 10 1.25 1.25 0 0 1 15 8.75z"
  }))));
});

/**
* @file 图标more
* @author zhanglili
*/
var IconMore =
/*#__PURE__*/
createIcon('more', SVG$1G);

var SVG$1H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M895.244 959.558H128.235V64.715h767.008v894.843zm-703.091-63.917h639.174V128.632H192.153v767.009z"
  }), React.createElement("path", {
    d: "M447.822 192.55h63.917v319.587h-63.917V192.55zm31.959 31.958l31.959 31.959h-63.917l31.958-31.959zm223.711-31.958h63.917v319.587h-63.917V192.55zm31.958 31.958l31.959 31.959h-63.917l31.958-31.959z"
  }), React.createElement("path", {
    d: "M610.226 425.741l-95.49-232.544h-66.914v63.918h24.064l105.105 255.959h67.526l100.845-255.959h22.047v-63.918h-65.564zm-421.292 214.23h194.971v-63.917H188.934z"
  }), React.createElement("path", {
    d: "M254.461 512.137v191.752h63.917V512.137zm240.729 39.758l-295.219 255.67 41.844 48.317 295.219-255.67zM383.905 767.806h191.752v63.917H383.905z"
  }));
});

/**
* @file 图标mpi
* @author zhanglili
*/
var IconMPI =
/*#__PURE__*/
createIcon('mpi', SVG$1H);

var SVG$1I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M344.86 454.64l64.47.06-.53 468.3-64.47-.07zm252.5-.31l64.49.07-.23 86.34.18 224.37h-.62l-.08 32.26 60.95-40.6 45.15 46.48-170.38 113.41zM409.79 128l-.08 82H408v.22h1.71l-.32 118.05H597.3V136.18h64.5v192.09h234.22v395.66H698.87v-64.47h132.62V392.72h-639v266.7h113.45v64.47H128V328.28h217l.41-80.92-60.87 40.6-45.15-46.48z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标nat
* @author zhanglili
*/
var IconNat =
/*#__PURE__*/
createIcon('nat', SVG$1I);

var SVG$1J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.255 18.41l-.218.32h-.079c-1.667-2.412-2.57-5.007-2.727-7.812h5.536c-.141 2.532-.892 4.894-2.264 7.104l-.248.388zm1.728.108c1.403-2.362 2.172-4.896 2.31-7.601h4.466a8.757 8.757 0 0 1-6.776 7.601zm-3.989-.033a8.755 8.755 0 0 1-6.636-7.567l4.347-.001c.137 2.693.9 5.216 2.29 7.568zM8.061 1.46C6.585 3.917 5.796 6.562 5.694 9.394H1.328a8.756 8.756 0 0 1 6.469-7.868l.264-.066zm1.68.19l.258-.38.01.014c1.737 2.496 2.655 5.19 2.77 8.11H7.22c.11-2.778.945-5.35 2.521-7.743zm2.176-.222a8.755 8.755 0 0 1 6.872 7.966h-4.485a16.3 16.3 0 0 0-2.252-7.74l-.135-.226z"
  }));
});

/**
* @file 图标network
* @author zhanglili
*/
var IconNetwork =
/*#__PURE__*/
createIcon('network', SVG$1J);

var SVG$1K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "16",
    height: "16"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    d: "M12.035 2l1.415 1.414-7.779 7.779-1.395.019-.019-1.434zM9.914 3.414l2.122 2.122M2 12.95h13",
    stroke: "#B8BABF",
    strokeLinejoin: "round"
  })));
});

/**
* @file 图标new-edit
* @author zhanglili
*/
var IconNewEdit =
/*#__PURE__*/
createIcon('new-edit', SVG$1K);

var SVG$1L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("path", {
    d: "M11 2.292a8.708 8.708 0 1 1 0 17.416H2.292V11A8.708 8.708 0 0 1 11 2.292zm0 1.833a6.875 6.875 0 0 0-6.871 6.639L4.125 11v6.875H11a6.875 6.875 0 0 0 6.871-6.639l.004-.236A6.875 6.875 0 0 0 11 4.125zm2.75 5.958v1.834h-5.5v-1.834h5.5z"
  }));
});

/**
* @file 图标news
* @author zhanglili
*/
var IconNews =
/*#__PURE__*/
createIcon('news', SVG$1L);

var SVG$1M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M808.021 690.231v236.286H216.044V690.231H98.727V513.016H925.73v177.215H808.021zm-59.072-59.072h117.709v-59.072H157.799v59.072h117.317v236.286H748.95V631.159zM852.38 248.396l-41.971 41.971c-64.975-80.38-164.376-131.781-275.783-131.781s-210.809 51.401-275.783 131.781l-41.971-41.971c75.851-90.982 190.041-148.881 317.755-148.881s241.902 57.899 317.753 148.881zm-84.024 84.024l-42.197 42.197c-42.928-59.306-112.725-97.887-191.534-97.887s-148.606 38.582-191.534 97.887l-42.197-42.197c54.021-69.813 138.627-114.762 233.73-114.762s179.71 44.949 233.732 114.762zm-84.687 84.687l-43.254 43.254c-19.36-38.822-59.461-65.488-105.79-65.488s-86.429 26.667-105.79 65.488l-43.254-43.254c31.543-48.917 86.511-81.306 149.044-81.306s117.501 32.389 149.044 81.306z"
  }));
});

/**
* @file 图标nsc
* @author zhanglili
*/
var IconNSC =
/*#__PURE__*/
createIcon('nsc', SVG$1M);

var SVG$1N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M840.947 447.401l-44.107-2.122c7.026-41.993-2.79-85.126-27.201-119.524-25.101-35.32-63.096-58.565-105.207-64.363l11.57-43.387c51.883 8.468 98.413 37.726 129.449 81.396 30.2 42.633 42.946 95.78 35.496 148zm103.595 1.344l-45.18-1.225c7.731-62.263-8.003-125.211-43.962-175.879-36.157-50.902-89.645-85.846-149.748-97.83l12.411-44.254c69.647 15.163 131.403 56.303 173.411 115.52 41.769 58.671 60.701 131.331 53.068 203.668zm-56.38 230.443v8.568c0 107.103-86.824 193.927-193.927 193.927H280.676c-111.835 0-202.495-90.66-202.495-202.495 0-102.013 75.435-186.408 173.567-200.445v-2.051c0-127.812 103.612-231.423 231.423-231.423s231.423 103.612 231.423 231.423v2.051c98.132 14.037 173.568 98.432 173.568 200.445zM656.738 476.693c0-95.859-77.709-173.567-173.567-173.567s-173.567 77.709-173.567 173.567v52.22l-49.664 7.104c-70.679 10.11-123.904 70.995-123.904 143.172 0 79.882 64.757 144.64 144.64 144.64h413.559c75.15 0 136.071-60.921 136.071-136.071v-8.568c0-72.177-53.225-133.062-123.904-143.172l-49.664-7.104v-52.221z"
  }));
});

/**
* @file 图标odp
* @author zhanglili
*/
var IconODP =
/*#__PURE__*/
createIcon('odp', SVG$1N);

var SVG$1O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M807.948 926.379H213.646V510.874H99.867v-57.26L510.106 94.71l414.26 358.817v57.348H807.948v415.504zm-535.237-59.066h476.172V451.809h83.285L510.3 173.019l-318.665 278.79h81.076v415.504z"
  }), React.createElement("path", {
    d: "M569.268 512.236h59.065v413.456h-59.065V512.236zm-118.131 59.066h59.065v354.391h-59.065V571.302zm-118.13 59.065h59.065v295.326h-59.065V630.367z"
  }));
});

/**
* @file 图标odw
* @author zhanglili
*/
var IconODW =
/*#__PURE__*/
createIcon('odw', SVG$1O);

var SVG$1P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M3.5 1.5h9v3h-9z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 2h2v1H1zm12 0h2v1h-2zM1 13h2v1H1zm12 0h2v1h-2z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 2h1v12H1zm13 0h1v12h-1z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M3.5 6.5h9v3h-9zm0 5h9v3h-9z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2h1v2H5zm0 10h1v2H5zm5-5h1v2h-1z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标oos
* @author zhanglili
*/
var IconOOS =
/*#__PURE__*/
createIcon('oos', SVG$1P);

var SVG$1Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M256.243 418.448v-63.721h318.606v63.721H383.685v191.164h446.049V418.448H702.292v63.721h63.721v63.722H447.407v-63.722H638.57V291.005H192.521v191.164h127.443v-63.721zM128.8 737.055h828.377v63.721H128.8zM319.964 864.497h382.328v63.722H319.964zM65.079 99.841h892.099v63.721H65.079V99.841z"
  }), React.createElement("path", {
    d: "M893.456 99.841h63.721v318.607h-63.721zm-828.377 0H128.8v700.935H65.079zm828.377 446.05h63.721v191.164h-63.721z"
  }));
});

/**
* @file 图标opera
* @author zhanglili
*/
var IconOpera =
/*#__PURE__*/
createIcon('opera', SVG$1Q);

var SVG$1R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "112 -112 1024 1024"
  }, props), React.createElement("path", {
    d: "M700.2 30.9v123h307.6v-123H700.2zm-61.5-61.5h430.6v246.1H638.7V-30.6zM269.6 646v123h246.1V646H269.6zm-61.5-61.5h369.1v246.1H208.1V584.5zm492.1-246.1V769h307.6V338.4H700.2zm-61.5-61.5h430.6v553.6H638.7V276.9zm-369.1-246v430.6h246.1V30.9H269.6zm-61.5-61.5h369.1V523H208.1V-30.6z"
  }));
});

/**
* @file 图标overview
* @author zhanglili
*/
var IconOverview =
/*#__PURE__*/
createIcon('overview', SVG$1R);

var SVG$1S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M374.08 79c27.68 0 54.53 1.34 80.11 3.85l21.61 2.44 20.92 3c113.08 17.93 192.43 59.92 192.43 108.86a44 44 0 0 1-.35 5.63v231.45l-.9.08q10.36-.84 21-.85c141.38 0 256 114.62 256 256s-114.62 256-256 256a254.85 254.85 0 0 1-151.07-49.3l.63.46a626.18 626.18 0 0 1-459.66-36q-16.31-10.23-23.26-16.09-6.22-5.24-16.29-17.18v-626c-.12-1.39-.19-2.78-.19-4.19 0-48.94 79.35-90.93 192.43-108.86l20.93-3L294 82.85c25.54-2.51 52.39-3.85 80.08-3.85zm334.77 413.54c-108.76 0-196.93 88.16-196.93 196.92s88.17 196.92 196.93 196.92 196.92-88.16 196.92-196.92-88.17-196.92-196.92-196.92zM118.27 672.81v128.3C240.19 864.64 375.8 881 504.92 850.2l3.91-1-.76-1a254.78 254.78 0 0 1-53-125l-.19-1.45v.32a626.2 626.2 0 0 1-336.61-49.26zm689-3v59.08H610.38v-59.12zm-689-213.58v151.2a567.12 567.12 0 0 0 332.56 55.76l3.4-.48-.08.84.21-2.06a255.75 255.75 0 0 1 100.52-176.57l1.7-1.28-4.28 1.29a626.23 626.23 0 0 1-434.03-28.74zm511.63-190c-33.58 17.48-79.59 31.38-133.18 39.88l-20.92 3-21.61 2.44c-25.58 2.52-52.43 3.86-80.11 3.86S319.54 314 294 311.45L272.36 309l-20.93-3c-53.57-8.5-99.58-22.39-133.16-39.87v124.65a567.12 567.12 0 0 0 511.59 0zM374.08 138.08c-78 0-150.44 11.49-202 30.84-22.45 8.42-39.28 17.76-49.08 26.45l-2 1.78 2 1.79c9.8 8.69 26.63 18 49.08 26.45 51.61 19.35 124 30.84 202 30.84s150.43-11.49 202.05-30.84c22.45-8.42 39.27-17.76 49.07-26.45l2-1.79-2-1.78c-9.8-8.69-26.62-18-49.07-26.45-51.62-19.35-124.06-30.84-202.05-30.84z"
  }))));
});

/**
* @file 图标owe
* @author zhanglili
*/
var IconOwe =
/*#__PURE__*/
createIcon('owe', SVG$1S);

var SVG$1T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M662.9 816l179.7-89.9v-331L623 286.9V232l274.6 129.8v397.3L677.9 864.6c-.6 45-37.2 81.3-82.4 81.3-45.5 0-82.4-36.9-82.4-82.4 0-45.5 36.9-82.4 82.4-82.4 27.9 0 52.5 13.8 67.4 34.9zm-67.3 74.9c15.2 0 27.5-12.3 27.5-27.5s-12.3-27.5-27.5-27.5-27.5 12.3-27.5 27.5 12.3 27.5 27.5 27.5zM348.5 150.3v-.7c0-45.5 36.9-82.4 82.4-82.4s82.4 36.9 82.4 82.4-37 82.4-82.5 82.4c-27.3 0-51.5-13.3-66.5-33.8l-180.6 97.9v364.2l219.6 120.8V836L128.8 693.2V262.8l219.7-112.5zm82.3 26.8c15.2 0 27.5-12.3 27.5-27.5s-12.3-27.5-27.5-27.5-27.5 12.3-27.5 27.5c.1 15.2 12.4 27.5 27.5 27.5zm75.3 376.7l161.2 66v58l-234.1 90.4v-56.7l43.5-17.2-162.9-62.9v-58l119.5-48.9v-.2l-.1-.2 41.5-16.8-151-61v-50.9l234-102.9v62.2l-58 22.7 157.7 64.4v50.9l-151.3 61.1zm41.8-76.1l35.1-14.2-151.7-59.4-33.2 13 149.8 60.6zm-110.1 99.2l-53.2 23.4L548 665.1v1l48.7-19.3-158.9-69.9z"
  }));
});

/**
* @file 图标paddle-cloud
* @author zhanglili
*/
var IconPaddleCloud =
/*#__PURE__*/
createIcon('paddle-cloud', SVG$1T);

var SVG$1U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.8 97.8L883 312.6v429.7L510.8 957.2 138.6 742.4V312.6L510.8 97.8zm0 70.8L200 348.1v358.8l310.8 179.4 310.8-179.4V348.1L510.8 168.6z"
  }), React.createElement("path", {
    d: "M265.2 343.3h245.6v368.3H265.2V343.3zm61.4 61.4v245.6h122.8V404.7H326.6zm245.6-61.4h61.4v368.3h-61.4V343.3zM695 404.7h61.4v245.6H695V404.7z"
  }));
});

/**
* @file 图标pandora
* @author zhanglili
*/
var IconPandora =
/*#__PURE__*/
createIcon('pandora', SVG$1U);

var SVG$1V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M894.2 164.6H231.8v791.9h454.8l.1-.1h207.6l-.1-791.8zm-86.9-98.7H130.9V846H187V116.8h620.3V65.9zM328.8 271.7h400.6v119.7H328.8V271.7zm0 227.3h400.6v119.7H328.8V499zm0 227.2h400.6V846H328.8V726.2z"
  }));
});

/**
* @file 图标paper
* @author zhanglili
*/
var IconPaper =
/*#__PURE__*/
createIcon('paper', SVG$1V);

var SVG$1W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M98.597 276.062h829.398v651.67H98.597v-651.67zm59.243 59.243V868.49h710.913V335.305H157.84z"
  }), React.createElement("path", {
    d: "M98.597 98.334h829.398v236.971H98.597V98.334zm59.243 59.243v118.485h710.913V157.577H157.84zm118.486 236.971h177.728v177.728H276.326V394.548zm59.242 59.242v59.243h59.243V453.79h-59.243zm236.971-59.242h177.728v177.728H572.539V394.548zm59.243 59.242v59.243h59.243V453.79h-59.243zm-59.243 177.728h177.728v177.728H572.539V631.518zm59.243 59.243v59.243h59.243v-59.243h-59.243zm-355.456-59.243h177.728v177.728H276.326V631.518zm59.242 59.243v59.243h59.243v-59.243h-59.243z"
  }));
});

/**
* @file 图标pdb
* @author zhanglili
*/
var IconPDB =
/*#__PURE__*/
createIcon('pdb', SVG$1W);

var SVG$1X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M349.5 675.5l122.2-26.9 337.2-330.4-104.1-103.9-328.4 339zm540-482l-58-58c-13.4-13.2-34.8-13.2-47.9 0l-60.7 60.7 106 106 60.7-60.5c13.1-13.6 13.1-35-.1-48.2z"
  }), React.createElement("path", {
    d: "M789.4 840.4H184.5V235.6h329.9v-55H129.5v714.8h714.9V510.5h-55z"
  }));
});

/**
* @file 图标pen-with-paper
* @author zhanglili
*/
var IconPenWithPaper =
/*#__PURE__*/
createIcon('pen-with-paper', SVG$1X);

var SVG$1Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512 65l392 223.5v447L512 959 120 735.5v-447L512 65zm0 73.672L184 325.681v372.637l328 187.009 328-187.01V325.682l-328-187.01zm207.698 211.12l33.067 54.795L544 530.566V791h-64V531.445L274.25 418.558l30.784-56.11L511.24 475.587l208.458-125.795z"
  }));
});

/**
* @file 图标product
* @author zhanglili
*/
var IconProduct =
/*#__PURE__*/
createIcon('product', SVG$1Y);

var SVG$1Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 15.75v3H1v-3zm0-7v3H1v-3zm0-7v3H1v-3z"
  }))));
});

/**
* @file 图标product-entries
* @author zhanglili
*/
var IconProductEntries =
/*#__PURE__*/
createIcon('product-entries', SVG$1Z);

var SVG$1_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M14 6v8H2V6zm-1 1H3v6h10zm0-3v1H3V4zm-1-2v1H4V2z"
  }))));
});

/**
* @file 图标project
* @author zhanglili
*/
var IconProject =
/*#__PURE__*/
createIcon('project', SVG$1_);

var SVG$1$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.62 62.77C263.311 62.77 62 264.058 62 512.373c0 248.307 201.312 449.611 449.62 449.611 248.306 0 449.61-201.304 449.61-449.611 0-248.315-201.311-449.603-449.61-449.603zm0 841.483c-70.649 0-127.927-47.193-127.927-105.392h255.853c0 58.19-57.279 105.392-127.927 105.392zm211.292-140.296h-422.61v-76.63H722.92v76.63h-.008zm-1.515-116.072H301.508c-1.396-1.611-2.825-3.198-4.173-4.832-43.259-52.526-53.447-79.947-63.341-107.892-.166-.92 52.455 10.75 89.77 19.145 0 0 19.201 4.444 47.273 9.561-26.953-31.595-42.957-71.759-42.957-112.811 0-90.127 69.125-168.884 44.187-232.542 24.271 1.976 50.233 51.225 51.986 128.228 25.803-35.657 36.602-100.775 36.602-140.7 0-41.339 27.239-89.358 54.485-91-24.287 40.029 6.292 74.345 33.476 159.473 10.195 31.976 8.894 85.787 16.765 119.913 2.61-70.878 14.798-174.295 59.762-210-19.836 44.964 2.936 101.227 18.511 128.276 25.128 43.639 40.362 76.701 40.362 139.233 0 41.925-15.48 81.399-41.592 112.256 29.69-5.57 50.193-10.593 50.193-10.593l96.42-18.812c.007-.008-14.005 57.611-67.84 113.097z"
  }));
});

/**
* @file 图标prom
* @author zhanglili
*/
var IconProm =
/*#__PURE__*/
createIcon('prom', SVG$1$);

var SVG$20 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M130.834 736.375H958.15v63.64H130.834v-63.64zM321.753 863.655h381.838v63.64H321.753v-63.64zM67.195 99.979H958.15v63.64H67.195v-63.64z"
  }), React.createElement("path", {
    d: "M894.51 99.979h63.64v318.198h-63.64V99.979zm-827.315 0h63.64v700.036h-63.64V99.979zM894.51 545.456h63.64v190.919h-63.64V545.456zm-509.117 63.64V481.817h318.198V227.258H321.753v63.64h318.198v127.279H321.753v254.559h381.838v-63.64H385.393z"
  }));
});

/**
* @file 图标qian-mo
* @author zhanglili
*/
var IconQianMo =
/*#__PURE__*/
createIcon('qian-mo', SVG$20);

var SVG$21 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M927 926.29H97V96.15h830v830.14zM156.29 867h711.42V155.45H156.29V867z"
  }), React.createElement("path", {
    d: "M627.79 293.38c26.28 24.2 39.83 57.62 39.83 100.29 0 31.96-9.26 59.7-27.04 83.21-7.12 8.51-26.28 26.98-57.61 54.72-15.63 13.55-26.28 26.35-33.41 39.14-9.23 15.63-13.49 32.72-13.49 51.88v16.39H479.2v-16.39c0-23.45 4.26-44.07 12.79-61.84 9.96-21.37 33.41-48.35 71.82-82.52 11.41-11.35 19.86-19.92 24.14-25.59 14.24-17.78 21.36-36.25 21.36-56.17 0-28.43-8.51-50.49-24.14-66.13-16.38-17.08-39.86-24.9-69.74-24.9-35.55 0-61.86 11.35-78.91 34.86-15.63 19.92-23.48 46.9-23.48 81.76H356.9c0-49.8 13.52-89.58 41.95-119.46 28.46-31.33 68.26-46.96 119.47-46.96 45.5.01 81.74 12.12 109.47 37.71zm-88.87 407.49c7.82 7.82 12.1 17.78 12.1 29.88 0 12.8-4.28 22.76-12.82 30.57-8.51 7.82-18.47 12.1-30.57 12.1-12.07 0-22.03-4.29-30.57-12.1-8.54-8.51-12.07-18.47-12.07-30.57 0-12.1 3.53-22.06 12.07-29.88 8.54-8.51 18.5-12.04 30.57-12.04 12.1-.01 22.75 3.52 31.29 12.04z"
  }));
});

/**
* @file 图标question-mark
* @author zhanglili
*/
var IconQuestionMark =
/*#__PURE__*/
createIcon('question-mark', SVG$21);

var SVG$22 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "none",
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M519.8 72l378.8 218.5v393.6l-122-71.1v244.1L504.8 698.9v252.2L126 730.4V339l378.8 218.5v67.4l207.7 121v-306L290.1 196.1v237.4l-64-36.9V85.3l293.6 169.4.1-182.7zM190 449.7v243.9l250.8 146.1V594.4L190 449.7zm393.7-267v108.9l192.9 111.2V539l58 33.8V327.5L583.7 182.7z"
  }));
});

/**
* @file 图标rdw
* @author zhanglili
*/
var IconRDW =
/*#__PURE__*/
createIcon('rdw', SVG$22);

var SVG$23 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.1 847.64c-117.62 0-224.04-61.55-285.66-162.28l117.62-117.51H64.01v279.79l78.42-78.34c84.02 117.51 218.44 190.26 369.67 190.26 224.04 0 414.48-162.28 442.49-386.11l-112.02-16.79C820.16 724.53 680.13 847.64 512.1 847.64zm369.67-593.16C797.75 136.97 663.33 64.22 512.1 64.22c-224.04 0-414.48 162.28-442.49 386.11l112.02 16.79c22.4-167.88 162.43-290.98 330.46-290.98 117.62 0 224.04 61.55 285.66 162.28L680.13 455.93h280.05V176.14l-78.41 78.34z"
  }));
});

/**
* @file 图标refresh
* @author zhanglili
*/
var IconRefresh =
/*#__PURE__*/
createIcon('refresh', SVG$23);

var SVG$24 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M12.5 8V6.5h2.755a6.382 6.382 0 0 0-5.268-2.75C6.473 3.75 3.63 6.55 3.63 10s2.843 6.25 6.357 6.25c2.847 0 5.315-1.856 6.1-4.486l.066-.24 1.454.37c-.871 3.42-4 5.856-7.62 5.856-4.337 0-7.857-3.467-7.857-7.75 0-4.283 3.52-7.75 7.857-7.75A7.893 7.893 0 0 1 16 5.011V3h1.5v5h-5z"
  }));
});

/**
* @file 图标refreshs
* @author zhanglili
*/
var IconRefreshs =
/*#__PURE__*/
createIcon('refreshs', SVG$24);

var SVG$25 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M11.5 17v1.5h-3V17zM3 16v-1.5h1.5v-6a5.51 5.51 0 0 1 4.75-5.45V1.53h1.5v1.52A5.51 5.51 0 0 1 15.5 8.5v6H17V16zm7-11.5a4 4 0 0 0-4 3.8v6.2h8v-6a4 4 0 0 0-3.8-4z"
  }))));
});

/**
* @file 图标remind
* @author zhanglili
*/
var IconRemind =
/*#__PURE__*/
createIcon('remind', SVG$25);

var SVG$26 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M734 192c69.947 0 132 50.325 132 112.403v354.958c0 62.079-62.053 112.404-132 112.404h-44V896L470 771.765H294c-69.947 0-132-50.325-132-112.404V304.403C162 242.325 224.053 192 294 192h440zm0 64H294c-19.13 0-37.76 6.77-51.107 17.962-11.151 9.35-16.723 20.007-16.893 29.981v355.418c0 10.107 5.57 20.947 16.893 30.442 13.176 11.049 31.5 17.787 50.371 17.958l.736.004h192.822L626 786.358l.001-78.593h108c19.13 0 37.76-6.77 51.107-17.962 11.151-9.351 16.723-20.007 16.893-29.982V304.403c0-10.106-5.57-20.946-16.893-30.441-13.176-11.05-31.5-17.788-50.371-17.962H734z"
  }), React.createElement("path", {
    d: "M583.059 512v64h-256v-64zM711 384v64H327v-64z"
  })));
});

/**
* @file 图标reply
* @author zhanglili
*/
var IconReply =
/*#__PURE__*/
createIcon('reply', SVG$26);

var SVG$27 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M97.517 276.035h829.768v651.961H97.517V276.035zm59.269 59.269v533.422h711.23V335.304h-711.23z"
  }), React.createElement("path", {
    d: "M512.401 631.65h296.346v177.807H512.401V631.65zm59.269 59.269v59.269h177.807v-59.269H571.67zM97.517 98.228h829.768v237.077H97.517V98.228zm59.269 59.269v118.538h711.23V157.497h-711.23zm59.269 237.076h592.692v59.269H216.055zm0 118.539h592.692v59.269H216.055zm0 177.807h237.077v59.269H216.055z"
  }));
});

/**
* @file 图标rms
* @author zhanglili
*/
var IconRMS =
/*#__PURE__*/
createIcon('rms', SVG$27);

var SVG$28 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M2 12h13v1H2zM5 14h6v1H5zM1 2h14v1H1V2zm13.5.5L14 3V2l.5.5z"
  }), React.createElement("path", {
    d: "M14 2h1v5h-1zM1 2h1v11H1zm13 7h1v3h-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M4.5 4.5h2v6h-2zm5 0h3v2h-3zm0 4h3v2h-3z"
  }));
});

/**
* @file 图标ros
* @author zhanglili
*/
var IconROS =
/*#__PURE__*/
createIcon('ros', SVG$28);

var SVG$29 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M293.465 281.461V170.637L65.584 422.066l227.881 259.527V563.674h57.3V507.15H236.941v24.403l-95.613-108.89 95.613-105.493v20.814h340.021v57.288h56.524V281.461z"
  }), React.createElement("path", {
    d: "M675.826 851.074l283.508-274.921-283.508-244.68v113.524l-41.829.099-210.593-.45-28.322-.06v283.603h280.744v122.885zm-41.823-349.455l70.151-.166 28.195-.067v-46.468L875.634 578.58 732.349 717.527v-45.862H451.605V501.23l182.398.389z"
  }));
});

/**
* @file 图标rpc
* @author zhanglili
*/
var IconRPC =
/*#__PURE__*/
createIcon('rpc', SVG$29);

var SVG$2a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512 274l399 265.5L512 805 113 539.5 512 274zm0 79.726L232.833 539.443 512 725.161l279.1-185.718L512 353.726z"
  }), React.createElement("path", {
    d: "M512 76l399 265.5L512 607 113 341.5 512 76zm0 79.726L232.833 341.443 512 527.161l279.1-185.718L512 155.726zM911 883v65H113v-65z"
  }));
});

/**
* @file 图标sci
* @author zhanglili
*/
var IconSCI =
/*#__PURE__*/
createIcon('sci', SVG$2a);

var SVG$2b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M9.5 3a6.49 6.49 0 0 1 5 10.67l3.07 3.07-1.08 1.06-3.1-3.09A6.5 6.5 0 1 1 9.5 3zm0 1.5a5 5 0 1 0 5 5 5 5 0 0 0-5-5z"
  }))));
});

/**
* @file 图标search
* @author zhanglili
*/
var IconSearch =
/*#__PURE__*/
createIcon('search', SVG$2b);

var SVG$2c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M868.822 396.468v295.974H512.249v59.194h415.768V337.273H512.249v59.195z"
  }), React.createElement("path", {
    d: "M630.638 720.75v147.987h59.195V720.75z"
  }), React.createElement("path", {
    d: "M571.444 868.737h177.584v-59.194H571.444zM157.08 335.984h177.585v59.195H157.08zm0 118.39h177.585v59.195H157.08zm0 118.389h177.585v59.195H157.08zM453.054 99.205h59.195v118.39h-59.195z"
  }), React.createElement("path", {
    d: "M97.885 99.205h414.364V158.4H97.885z"
  }), React.createElement("path", {
    d: "M97.885 99.205h59.195v828.727H97.885z"
  }), React.createElement("path", {
    d: "M97.885 868.737h414.363v59.195H97.885v-59.195zm355.169 59.195v-59.195l29.597 29.597-29.597 29.598z"
  }), React.createElement("path", {
    d: "M453.054 276.79h59.195v651.142h-59.195z"
  }));
});

/**
* @file 图标seer
* @author zhanglili
*/
var IconSeer =
/*#__PURE__*/
createIcon('seer', SVG$2c);

var SVG$2d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M12.296 1.973V4.13c.495.19.963.446 1.39.759l.252.194.884-.505.987-.574.574.987 1.148 1.998.574.988-.987.574-.884.505c.089.526.103 1.06.044 1.59l-.044.316.884.505.987.574-.574.987-1.148 1.998-.574.988-.987-.574-.884-.506a6.016 6.016 0 0 1-1.348.831l-.294.122v2.159H7.704v-2.159a6.016 6.016 0 0 1-1.39-.758l-.252-.195-.884.506-.987.574-.574-.988-1.148-1.998-.574-.987.987-.574.884-.505a5.741 5.741 0 0 1-.044-1.59l.044-.316-.884-.505-.987-.574.574-.988 1.148-1.998.574-.987.987.574.884.505a6.016 6.016 0 0 1 1.348-.83l.294-.123V1.973h4.592zm-1.25 1.249H8.953v1.767l-.8.309a4.766 4.766 0 0 0-1.06.571l-.24.184-.666.542-1.543-.882-1.041 1.811 1.54.88-.144.86c-.067.395-.08.797-.04 1.194l.04.297.144.86-1.54.88 1.041 1.81 1.543-.88.665.542c.313.255.656.47 1.022.637l.279.118.8.308v1.766h2.093V15.03l.801-.308a4.766 4.766 0 0 0 1.06-.572l.24-.183.666-.543 1.543.881 1.04-1.81-1.54-.88.145-.86c.067-.395.08-.796.04-1.194l-.04-.297-.144-.86 1.539-.881-1.04-1.81-1.543.882-.665-.542a4.766 4.766 0 0 0-1.022-.638l-.279-.117-.8-.309-.001-1.767zM10 7.148a2.852 2.852 0 1 1 0 5.704 2.852 2.852 0 0 1 0-5.704zm0 1.25a1.602 1.602 0 1 0 0 3.204 1.602 1.602 0 0 0 0-3.204z"
  }));
});

/**
* @file 图标set-up
* @author zhanglili
*/
var IconSetUp =
/*#__PURE__*/
createIcon('set-up', SVG$2d);

var SVG$2e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M766.974 766.066c105.685 0 191.36-85.675 191.36-191.36s-85.675-191.36-191.36-191.36-191.36 85.675-191.36 191.36 85.674 191.36 191.36 191.36zm0-63.787c-70.457 0-127.573-57.117-127.573-127.573s57.116-127.573 127.573-127.573 127.573 57.116 127.573 127.573-57.117 127.573-127.573 127.573z"
  }), React.createElement("path", {
    d: "M766.974 638.492c35.228 0 63.787-28.558 63.787-63.787s-28.558-63.787-63.787-63.787-63.787 28.558-63.787 63.787 28.558 63.787 63.787 63.787zM735.08 734.172v159.467h63.787V734.172z"
  }), React.createElement("path", {
    d: "M894.547 829.852H640.003v63.787h254.544zm0-701.652h63.787v255.146h-63.787V128.2z"
  }), React.createElement("path", {
    d: "M65.321 128.2h893.012v63.786H65.321zm0 63.786h63.787v637.866H65.321z"
  }), React.createElement("path", {
    d: "M65.321 766.066h446.506v63.786H65.321zm127.573-510.293H830.76v63.786H192.894zm0 127.573h318.933v63.787H192.894z"
  }));
});

/**
* @file 图标smart-monitor
* @author zhanglili
*/
var IconSmartMonitor =
/*#__PURE__*/
createIcon('smart-monitor', SVG$2e);

var SVG$2f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.398 673.155c105.268 0 190.605-85.337 190.605-190.605s-85.337-190.605-190.605-190.605-190.604 85.337-190.604 190.605 85.336 190.605 190.604 190.605zm0-63.535c-70.179 0-127.07-56.891-127.07-127.07s56.891-127.07 127.07-127.07 127.07 56.891 127.07 127.07-56.891 127.07-127.07 127.07zm287.374 13.223l-57.769-26.446c16.704-36.489 25.459-76.224 25.459-117.244 0-38.732-7.804-76.324-22.751-111.14l58.382-25.065c18.331 42.697 27.904 88.813 27.904 136.205-.001 50.196-10.742 98.946-31.225 143.69zm-577.835-275.98l58.582 24.594c-14.627 34.842-22.26 72.405-22.26 111.093 0 41.167 8.643 81.053 25.139 117.715l-57.94 26.069c-20.166-44.819-30.733-93.586-30.733-143.784-.001-47.171 9.329-93.092 27.212-135.687zM130.189 736.69h825.954v63.535H130.189zM320.794 863.759h381.209v63.535H320.794zM66.654 101.341h889.489v63.535H66.654v-63.535z"
  }), React.createElement("path", {
    d: "M892.608 101.341h63.535v317.674h-63.535zm-825.954 0h63.535v698.884H66.654zm825.954 444.744h63.535V736.69h-63.535z"
  }));
});

/**
* @file 图标solaria
* @author zhanglili
*/
var IconSolaria =
/*#__PURE__*/
createIcon('solaria', SVG$2f);

var SVG$2g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513 561.6c98.8 0 178.9-80.1 178.9-178.9S611.8 203.8 513 203.8s-178.9 80.1-178.9 178.9S414.2 561.6 513 561.6zm0-59.6c-65.9 0-119.3-53.4-119.3-119.3S447.1 263.5 513 263.5s119.3 53.4 119.3 119.3S578.9 502 513 502zm269.7 12.4l-54.2-24.8c15.7-34.2 23.9-71.5 23.9-110.1 0-36.4-7.3-71.6-21.4-104.3l54.8-23.5C803 291.8 812 335.1 812 379.5c.1 47.2-10 92.9-29.3 134.9zm-542.3-259l55 23.1c-13.7 32.7-20.9 68-20.9 104.3 0 38.6 8.1 76.1 23.6 110.5l-54.4 24.5c-18.9-42.1-28.8-87.8-28.8-135-.1-44.4 8.7-87.5 25.5-127.4z"
  }), React.createElement("path", {
    d: "M240.7 612.5l-40.5 31c-66.6-71-104.7-163-104.7-260.8 0-95 35.9-184.6 99.1-254.7l39.6 32c-55.2 61.3-86.5 139.6-86.5 222.7-.1 86.3 33.8 167.4 93 229.8zm585.6 33.1l-34.6-36.4c55.9-61.5 87.7-140.6 87.7-224.7 0-85.3-32.7-165.4-89.9-227.2l39.6-31c64.6 70.4 101.5 161.4 101.5 258.2-.1 98.1-38 190.2-104.3 261.1zM513 597.5l298.2 298.2H214.8L513 597.5zM358.8 836h308.4L513 681.8 358.8 836z"
  }));
});

/**
* @file 图标sonar
* @author zhanglili
*/
var IconSonar =
/*#__PURE__*/
createIcon('sonar', SVG$2g);

var SVG$2h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M128.936 64.294h767.238v895.111H128.936V64.294zm63.937 63.936v767.238h639.365V128.23H192.873z"
  }), React.createElement("path", {
    d: "M512.555 192.167h255.746v63.936H512.555zm191.81 191.809h63.936v127.873h-63.936zm-191.81 63.937h191.81v63.936h-191.81z"
  }), React.createElement("path", {
    d: "M512.555 192.167h63.937v191.809h-63.937zm63.937 127.873h191.809v63.936H576.492zM189.653 639.722h195.029v-63.936H189.653z"
  }), React.createElement("path", {
    d: "M255.2 511.849v191.81h63.936v-191.81zm240.801 39.771L200.693 807.366l41.857 48.331 295.307-255.746zM384.682 767.595h191.809v63.936H384.682v-63.936zm127.873 63.937v-63.936l31.968 31.968-31.968 31.968z"
  }));
});

/**
* @file 图标spark
* @author zhanglili
*/
var IconSpark =
/*#__PURE__*/
createIcon('spark', SVG$2h);

var SVG$2i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M960 64v896H64V64h896zm-64 64H128v768h768V128zm-192 64v128h128v512H320V704H192V192h512zm64 192H384v384h384V384zM640 256H256v384h64V320h320v-64zm0 320v64H448v-64h192zm64-128v64H448v-64h256z"
  }));
});

/**
* @file 图标ssm
* @author zhanglili
*/
var IconSSM =
/*#__PURE__*/
createIcon('ssm', SVG$2i);

var SVG$2j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.069 129.293c25.92 0 48.222 15.357 59.331 38.478L648.33 333.2c3.703 7.679 11.11 11.518 14.812 11.518l178.078 26.96c26.005 3.84 44.52 23.122 51.926 46.156 7.405 23.122 0 49.995-14.812 69.278L752.35 617.9c-3.703 3.838-7.406 11.516-7.406 19.194l29.623 180.872c3.703 26.96-7.406 49.995-26.005 65.439-18.514 15.356-48.222 15.356-70.524 3.839L518.475 802.61c-7.406-3.839-14.812-3.839-18.515 0l-155.776 88.473c-22.302 11.517-48.222 11.517-70.524-3.84-18.515-15.356-29.708-42.316-26.005-65.438l29.708-180.784-.004-1.77-.01-1.052-.013-.69-.019-.687-.026-.683c-.005-.114-.01-.227-.017-.34l-.04-.676a40.498 40.498 0 0 0-.024-.336l-.056-.667c-.477-5.095-2.045-9.624-7.197-12.295L143.804 487.111c-14.811-19.196-22.302-46.156-14.811-69.278 7.49-23.121 29.707-42.317 51.925-46.156l178.078-26.96c7.406 0 14.812-3.84 14.812-11.518l77.93-165.428c11.109-23.121 33.41-38.478 59.331-38.478zm0 64.006l-.09.065c-.427.32-.947.936-1.433 1.88l-.082.165-74.385 157.901-.1.365c-4.684 16.48-14.929 30.604-28.822 40.4l-.59.41c-12.044 8.325-25.772 12.835-39.635 13.953l-.557.042-172.356 26.094-.07.044c-.297.193-.636.441-.986.736l-.212.182c-.613.54-1.153 1.13-1.559 1.68l-.132.186.011.172c.034.449.112.99.242 1.607l.07.315c.49 2.115 1.44 4.391 2.671 6.434l.256.414L312.206 573.31l.503.406c10.897 8.87 18.905 20.408 23.588 33.454l.225.633c3.646 10.434 4.653 18.855 4.816 29.16l.013 1.05.011 1.902.004 6.308-30.381 184.886.016.1c.094.556.287 1.26.58 2.034l.114.294c.2.497.424.976.657 1.423l.14.263.091-.023a7.49 7.49 0 0 0 1.032-.391l.345-.162 150.112-85.256.375-.265c12.803-9.016 27.72-13.272 42.73-13.392l.652-.002c13.798 0 27.202 3.512 39.357 9.679l1.011.52 159.297 84.492.181.089c.747.343 1.677.618 2.603.78l.098.016.017-.023c.724-1.162.955-2.327.857-3.777l-.031-.348-30.275-184.858v-5.207c0-23.566 9.602-47.033 24.844-63.105l.468-.49 122.677-127.357.087-.14c1.158-1.926 2.064-4.041 2.582-6.041l.112-.46c.226-.975.327-1.79.336-2.39v-.169l-.03-.082c-.309-.81-.67-1.47-1.004-1.928l-.061-.081-175.205-26.526-.755-.082c-26.951-3.119-51.504-21.41-63.902-46.408l-.536-1.098-77.896-165.354-.069-.14c-.486-.944-1.006-1.56-1.432-1.88l-.091-.065z"
  }));
});

/**
* @file 图标star
* @author zhanglili
*/
var IconStar =
/*#__PURE__*/
createIcon('star', SVG$2j);

var SVG$2k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M344.184 891.084c-22.302 11.517-48.222 11.517-70.524-3.84-18.515-15.356-29.708-42.316-26.005-65.438l29.708-180.784c0-7.678 0-15.356-7.406-19.196L143.804 487.111c-14.811-19.196-22.302-46.156-14.811-69.278 7.49-23.121 29.707-42.317 51.925-46.156l178.078-26.96c7.406 0 14.812-3.84 14.812-11.518l77.93-165.428c11.109-23.121 33.41-38.478 59.331-38.478 25.92 0 48.222 15.357 59.331 38.478L648.33 333.2c3.703 7.679 11.11 11.518 14.812 11.518l178.078 26.96c26.005 3.84 44.52 23.122 51.926 46.156 7.405 23.122 0 49.995-14.812 69.278L752.35 617.9c-3.703 3.838-7.406 11.516-7.406 19.194l29.623 180.872c3.703 26.96-7.406 49.995-26.005 65.439-18.514 15.356-48.222 15.356-70.524 3.839L518.475 802.61c-7.406-3.839-14.812-3.839-18.515 0l-155.776 88.473z"
  }));
});

/**
* @file 图标star-fill
* @author zhanglili
*/
var IconStarFill =
/*#__PURE__*/
createIcon('star-fill', SVG$2k);

var SVG$2l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M482.956 678.375v167.064h55.688V678.375zM288.048 399.934h167.064v-55.688H288.048zm294.669-76.736L325.507 545.95l36.457 42.096 257.21-222.752z"
  }), React.createElement("path", {
    d: "M65.295 177.182h891.009v556.881H65.295V177.182zm55.688 55.688v445.505h779.633V232.87H120.983zm167.065 556.881h445.504v55.688H288.048z"
  }), React.createElement("path", {
    d: "M343.736 288.558h55.688v167.064h-55.688zM510.8 511.31h167.064v55.688H510.8z"
  }));
});

/**
* @file 图标stream-cloud
* @author zhanglili
*/
var IconStreamCloud =
/*#__PURE__*/
createIcon('stream-cloud', SVG$2l);

var SVG$2m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M14 2v12H2V2zm-1 4H3v7h10zM5 7v1H4V7zm2 0v1H6V7zm2 0v1H8V7zm4-4H3v2h10z"
  }))));
});

/**
* @file 图标sub-project
* @author zhanglili
*/
var IconSubProject =
/*#__PURE__*/
createIcon('sub-project', SVG$2m);

var SVG$2n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M951.7 509.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M475.3 686.8L289.5 536.6c-1.8-1.4-2-4.1-.4-5.8l47.3-52c1.4-1.6 3.8-1.8 5.5-.4l129 104.5L683.4 331c1.4-1.7 3.9-1.9 5.6-.5l56.4 46.3c1.7 1.4 2 4 .5 5.7l-265 303.8c-1.5 1.6-3.9 1.8-5.6.5z"
  }));
});

/**
* @file 图标success-circle-o
* @author zhanglili
*/
var IconSuccessCircleO =
/*#__PURE__*/
createIcon('success-circle-o', SVG$2n);

var SVG$2o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.4 65.2c-247 0-447.2 200.2-447.2 447.2s200.2 447.2 447.2 447.2 447.2-200.2 447.2-447.2S758.4 65.2 511.4 65.2zm-29.3 624.2L294.7 537.9c-1.3-1.1-1.5-3.1-.3-4.4l48.7-53.5c1.1-1.2 2.9-1.3 4.1-.3l129.7 105.1L690 332.3c1.1-1.3 2.9-1.4 4.2-.4l57.9 47.6c1.3 1.1 1.5 3 .4 4.3L486.2 689c-1.1 1.2-2.9 1.4-4.1.4z"
  }));
});

/**
* @file 图标success-solid
* @author zhanglili
*/
var IconSuccessSolid =
/*#__PURE__*/
createIcon('success-solid', SVG$2o);

var SVG$2p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M672.2 670.9v-52.2h23.4c65.1 0 117.8-54.9 117.8-122.7v-7.7c0-65.1-46.1-120-107.3-129.1l-43-6.4v-47.1c0-86.4-67.3-156.5-150.3-156.5s-150.3 70.1-150.3 156.5v47.1l-43 6.4c-61.2 9.1-107.3 64-107.3 129.1 0 72 56.1 130.4 125.3 130.4h15.9v52.2h-15.9c-96.8 0-175.4-81.8-175.4-182.6 0-92 65.3-168.1 150.3-180.8v-1.8C312.4 190.4 402.1 97 512.8 97s200.4 93.4 200.4 208.7v1.8c85 12.7 150.3 88.8 150.3 180.8v7.7c0 96.6-75.2 174.9-167.9 174.9h-23.4zm-510.1 63.7h191.3V926H162.1V734.6zm63.7 63.8v63.8h63.8v-63.8h-63.8zm191.3-63.8h191.3V926H417.1V734.6zm63.8 63.8v63.8h63.8v-63.8h-63.8z"
  }), React.createElement("path", {
    d: "M353.4 798.4h127.5v63.8H353.4zm255 0h127.5v63.8H608.4zm-255-318.8h318.8v63.8H353.4z"
  }), React.createElement("path", {
    d: "M480.9 352h63.8v318.8h-63.8zm191.3 382.6h191.3V926H672.2V734.6zm63.8 63.8v63.8h63.8v-63.8H736z"
  }));
});

/**
* @file 图标table-storage
* @author zhanglili
*/
var IconTableStorage =
/*#__PURE__*/
createIcon('table-storage', SVG$2p);

var SVG$2q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M610.796 140.679c39.362 22.318 55.332 71.747 36.698 113.585l-44.44 110.804h205.99c18.154-.005 35.396 8.118 47.168 22.223 11.771 14.104 16.888 32.77 13.997 51.061l-53.267 336.915C809.684 821.216 770.827 855 725.227 855H215.938C181.731 855 154 826.697 154 791.783V428.285c0-34.914 27.73-63.217 61.938-63.217h79.25c18.46 0 35.957-8.401 47.724-22.917l145.71-179.757c30.623-35.719 81.524-44.766 122.174-21.715zm-31.57 55.672c-13.673-7.754-30.58-4.952-41.363 6.958l-.23.255-145.006 178.891c-23.638 29.159-58.903 46.27-96.304 46.608l-1.134.005-77.19-.001V791h507.228c13.733 0 25.873-10.435 28.426-25.276l.074-.45 53.154-336.207H508.429l80.112-199.743.49-1.099c5.235-11.754.854-25.597-9.48-31.687l-.325-.187z"
  }), React.createElement("path", {
    d: "M298.4 396.213h71.7v452h-71.7z"
  })));
});

/**
* @file 图标thumbsup
* @author zhanglili
*/
var IconThumbsup =
/*#__PURE__*/
createIcon('thumbsup', SVG$2q);

var SVG$2r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M298.4 364.983V855h-82.462C181.731 855 154 826.697 154 791.783V428.285c0-34.914 27.73-63.217 61.938-63.217h79.25c1.075 0 2.146-.029 3.213-.085zm312.396-224.304c39.362 22.318 55.332 71.747 36.698 113.585l-44.44 110.804h205.99c18.154-.005 35.396 8.118 47.168 22.223 11.771 14.104 16.888 32.77 13.997 51.061l-53.267 336.915C809.684 821.216 770.827 855 725.227 855H370.1V308.61l118.522-146.216c30.623-35.719 81.524-44.766 122.174-21.715z"
  }));
});

/**
* @file 图标thumbsup-fill
* @author zhanglili
*/
var IconThumbsupFill =
/*#__PURE__*/
createIcon('thumbsup-fill', SVG$2r);

var SVG$2s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M256 128v64h512v-64zm128 704v64h256v-64zm256.64-63.872V621.312h175.296a32 32 0 0 0 22.08-55.232L512 256 185.984 566.08a32 32 0 0 0 22.08 55.232h178.24l-.832 146.816h255.104zm-64.064-64H449.6l.96-146.816H288.128L512 344.384l223.808 212.928H576.576v146.816z"
  }));
});

/**
* @file 图标top
* @author zhanglili
*/
var IconTop =
/*#__PURE__*/
createIcon('top', SVG$2s);

var SVG$2t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M256 128v64h512v-64zm128 704v64h256v-64zm256.896-63.872V621.312h175.04a32 32 0 0 0 22.08-55.232L512 256 185.984 566.08a32 32 0 0 0 22.08 55.232h177.6l-.896 146.816h256.128z"
  }));
});

/**
* @file 图标top-fill
* @author zhanglili
*/
var IconTopFill =
/*#__PURE__*/
createIcon('top-fill', SVG$2t);

var SVG$2u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M12.33 10.946l.616-.61-4.907-4.948-4.985 4.943.61.615 4.37-4.333z"
  }));
});

/**
* @file 图标top-point
* @author zhanglili
*/
var IconTopPoint =
/*#__PURE__*/
createIcon('top-point', SVG$2u);

var SVG$2v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1-2"
  }, React.createElement("path", {
    d: "M11.5 3v1h-3v9h-1V4h-3V3zm-5 2v6h-1V5zm4 0v6h-1V5zm2 1v4h-1V6zm-8 0v4h-1V6z"
  }), React.createElement("path", {
    d: "M15 1v14H1v-4.12h1V14h12V2H2v4H1V1z"
  }), React.createElement("path", {
    d: "M1.5 9.59L2.92 11H.09L1.5 9.59z"
  }))))));
});

/**
* @file 图标tts
* @author zhanglili
*/
var IconTTS =
/*#__PURE__*/
createIcon('tts', SVG$2v);

var SVG$2w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M593.07 607.58c105.78 0 191.5 86.85 195.43 195l.14 7.77v46.38a27.48 27.48 0 0 1-27.47 27.48h-13.72A27.48 27.48 0 0 1 720 856.73v-46.38c0-71.79-61.2-132.17-129.88-132.17l-158.53-1.51c-67.61 0-123.31 55.9-126.72 126.77l-.18 6.91v46.38a27.47 27.47 0 0 1-27.47 27.48h-13.75A27.48 27.48 0 0 1 236 856.73v-46.38c0-109.11 83.26-198.51 188.05-202.6zM512.34 139c117.9 0 213.47 96.14 213.47 214.78s-95.57 214.74-213.47 214.74-213.49-96.14-213.49-214.76S394.42 139 512.34 139zm0 69.1c-80 0-144.82 65.23-144.82 145.68s64.83 145.67 144.82 145.67 144.8-65.22 144.8-145.67-64.83-145.68-144.8-145.68z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标user
* @author zhanglili
*/
var IconUser =
/*#__PURE__*/
createIcon('user', SVG$2w);

var SVG$2x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 14"
  }, props), React.createElement("path", {
    d: "M8.75 3.125A.125.125 0 0 0 8.625 3h-6a.125.125 0 0 0-.125.125v.75c0 .069.056.125.125.125h6a.125.125 0 0 0 .125-.125v-.75zM8.625 5.25h-6a.125.125 0 0 0-.125.125v.75c0 .069.056.125.125.125h6a.125.125 0 0 0 .125-.125v-.75a.125.125 0 0 0-.125-.125zM5.5 7.5H2.625a.125.125 0 0 0-.125.125v.75c0 .069.056.125.125.125H5.5a.125.125 0 0 0 .125-.125v-.75A.125.125 0 0 0 5.5 7.5zm-.75 4.813h-3.5v-11H10v5.375c0 .068.056.125.125.125H11a.125.125 0 0 0 .125-.125v-6a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v12.25a.5.5 0 0 0 .5.5H4.75a.125.125 0 0 0 .125-.126v-.874a.125.125 0 0 0-.125-.126zm5.575-1.163a2.25 2.25 0 1 0-3.025 0 3.07 3.07 0 0 0-1.55 2.533c-.003.07.055.13.125.13h.752c.065 0 .12-.052.125-.12a2.066 2.066 0 0 1 2.06-1.943c1.099 0 2 .863 2.061 1.944a.125.125 0 0 0 .125.118h.752a.124.124 0 0 0 .125-.13 3.065 3.065 0 0 0-1.55-2.532zM8.813 8.234a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z"
  }));
});

/**
* @file 图标user-account
* @author zhanglili
*/
var IconUserAccount =
/*#__PURE__*/
createIcon('user-account', SVG$2x);

var SVG$2y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M592.57 607.58c105.78 0 191.5 86.85 195.43 195l.13 7.77v46.38a27.47 27.47 0 0 1-27.47 27.48H747a27.48 27.48 0 0 1-27.47-27.48v-46.38c0-71.79-61.21-132.17-129.88-132.17l-158.53-1.51c-67.61 0-123.31 55.9-126.73 126.77l-.17 6.91v46.38a27.48 27.48 0 0 1-27.47 27.48H263a27.48 27.48 0 0 1-27.47-27.48v-46.38c0-109.11 83.26-198.51 188.05-202.6zm262.94 9.1l1.6.51 1.55.66c63.09 29.41 105.45 96.83 108.47 173.06l.08 31.38a27.47 27.47 0 0 1-27.38 27.56H926.1a27.48 27.48 0 0 1-27.35-25l-.12-2.5v-22.84c0-49.41-24.12-92.93-59.91-114.2-.73-.43-1.47-.84-2.22-1.22A27.47 27.47 0 0 1 822.63 652l5.93-20.43a21.76 21.76 0 0 1 26.95-14.89zm-686.79 0a21.77 21.77 0 0 1 26.95 14.87l5.92 20.45a27.47 27.47 0 0 1-13.87 32.11c-.75.38-1.49.79-2.21 1.22-35.8 21.27-59.89 64.79-59.92 114.2v22.87l-.12 2.5a27.48 27.48 0 0 1-27.35 25H84.38A27.48 27.48 0 0 1 57 822.31l.08-31.38c3-76.23 45.38-143.65 108.48-173.06l1.54-.66 1.6-.51zM511.84 139c117.89 0 213.47 96.14 213.47 214.78s-95.58 214.74-213.47 214.74-213.5-96.14-213.5-214.76S393.92 139 511.84 139zm281.92 45.1l1.82.55 1.76.7c64.32 28.64 107.1 94.49 107.1 168.43 0 72.31-41 136.92-103 166.48l-4.56 2.1A23.27 23.27 0 0 1 765 507l-5.12-19.47a26.56 26.56 0 0 1 11.64-29.29l2.17-1.2c37.25-18.59 62.08-58.37 62.08-103.29 0-43.42-23.22-82.07-58.44-101.36l-3.81-2a26.23 26.23 0 0 1-13.7-30.17l5.08-19.32a23.62 23.62 0 0 1 28.86-16.8zm-563.88 0a23.63 23.63 0 0 1 28.84 16.82l5.08 19.32a26.25 26.25 0 0 1-13.7 30.17l-3.81 2c-35.23 19.29-58.45 57.94-58.45 101.36 0 44.92 24.83 84.7 62.09 103.29l2.16 1.2a26.54 26.54 0 0 1 11.64 29.29L258.61 507a23.26 23.26 0 0 1-31.91 15.35l-4.57-2.1c-62-29.56-103-94.17-103-166.48 0-73.94 42.79-139.79 107.1-168.43l1.77-.7 1.82-.55zm282 24c-80 0-144.82 65.23-144.82 145.68s64.83 145.67 144.82 145.67 144.79-65.22 144.79-145.67S591.81 208.1 511.84 208.1z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标user-group
* @author zhanglili
*/
var IconUserGroup =
/*#__PURE__*/
createIcon('user-group', SVG$2y);

var SVG$2z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M800 225v702H97V225h703zm-64 64H161v574h575V289zM587.825 394.91l56.437 30.18-177.544 332-57.096-1.303-158.5-332 57.756-27.574 131.24 274.902L587.825 394.91zM927 97v64h-.5v573.5h-64V161H290V97h637z"
  }));
});

/**
* @file 图标version
* @author zhanglili
*/
var IconVersion =
/*#__PURE__*/
createIcon('version', SVG$2z);

var SVG$2A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M4 1H1v3H0V0h4v1zm0 14H1v-3H0v4h4v-1zm8-14h3v3h1V0h-4v1zm0 14h3v-3h1v4h-4v-1zm4-6v1H0V9z"
  }), React.createElement("path", {
    d: "M8 13c-1.63 0-3.16-.666-4.595-1.998h1.586c.903.621 1.83.948 2.784.993L8 12c1.033 0 2.035-.328 3.009-.998h1.586C11.161 12.334 9.629 13 8 13zM8 3c2.577 0 4.91 1.667 7 5a19.59 19.59 0 0 1-.671 1.002h-1.252c.227-.286.452-.593.676-.921l.053-.082-.053-.08c-1.74-2.553-3.58-3.823-5.528-3.914L8 4C5.969 4 4.054 5.268 2.247 7.92L2.193 8l.054.08c.224.329.449.636.676.922H1.67C1.445 8.686 1.221 8.352 1 8c2.09-3.333 4.423-5 7-5zm0 2a3 3 0 0 1 2.829 4l-1.097.001a2 2 0 1 0-3.464 0H5.171A3 3 0 0 1 8 5z"
  }));
});

/**
* @file 图标vic
* @author zhanglili
*/
var IconVic =
/*#__PURE__*/
createIcon('vic', SVG$2A);

var SVG$2B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    stroke: "#666",
    d: "M1.5 1.5h3v13h-3zm5 0h3v13h-3zm5 0h3v7h-3z"
  }), React.createElement("path", {
    d: "M13 7h3v3h-3z"
  }), React.createElement("circle", {
    cx: "11.5",
    cy: "10",
    r: "3",
    fill: "#FFF",
    stroke: "#666"
  }), React.createElement("path", {
    stroke: "#666",
    d: "M13 12.022l1.52 2.736m-7.861-9.74h2.88m2.12 0h2.861"
  }), React.createElement("path", {
    d: "M3 4h3v2H3z"
  }), React.createElement("path", {
    stroke: "#666",
    d: "M1.623 8.018H4.5m-2.877 3H4.5"
  })));
});

/**
* @file 图标vms
* @author zhanglili
*/
var IconVMS =
/*#__PURE__*/
createIcon('vms', SVG$2B);

var SVG$2C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M98.917 276.272h829.467v651.724H98.917V276.272zm59.247 59.247v533.229h710.971V335.519H158.164z"
  }), React.createElement("path", {
    d: "M98.917 98.529h829.467v236.99H98.917V98.529zm59.247 59.248v118.495h710.971V157.777H158.164zm59.248 236.99h236.99V572.51h-236.99V394.767zm59.248 59.248v59.248h118.495v-59.248H276.66zm-59.248 177.743h592.476v59.247H217.412zm0 118.495h592.476V809.5H217.412zm355.486-236.991h236.99v59.248h-236.99z"
  }));
});

/**
* @file 图标vrmc
* @author zhanglili
*/
var IconVRMC =
/*#__PURE__*/
createIcon('vrmc', SVG$2C);

var SVG$2D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 12"
  }, props), React.createElement("path", {
    d: "M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 11c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
  }), React.createElement("path", {
    d: "M6 2H5v5h4V6H6z"
  }));
});

/**
* @file 图标waiting
* @author zhanglili
*/
var IconWaiting =
/*#__PURE__*/
createIcon('waiting', SVG$2D);

var SVG$2E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 5.45c3.096 0 5.605 2.646 5.605 5.91v4.85h2.497v2.54H1.911v-2.54h2.483v-4.85c0-3.264 2.51-5.91 5.606-5.91zM3.153 3.817l2.053 2.127-1.094 1.058-2.053-2.127 1.094-1.058zm13.86-.004l1.094 1.059-2.047 2.121-1.095-1.058 2.048-2.122zM10.762 1.25V4.2H9.238V1.25h1.524z"
  }));
});

/**
* @file 图标warn
* @author zhanglili
*/
var IconWarn =
/*#__PURE__*/
createIcon('warn', SVG$2E);

var SVG$2F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("path", {
    d: "M16.042 17.875v1.833H5.958v-1.833h10.084zm3.666-15.583v13.75H2.292V2.292h17.416zm-1.833 1.833H4.125v10.083h13.75V4.125zm-4.406 2.55l1.277 1.316-2.017 1.958h-2.67l-1.35 1.31L7.43 9.945l1.885-1.828 2.669-.001 1.484-1.44z"
  }));
});

/**
* @file 图标workbench
* @author zhanglili
*/
var IconWorkbench =
/*#__PURE__*/
createIcon('workbench', SVG$2F);

var SVG$2G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("path", {
    d: "M19.5 2v12a6 6 0 0 1-6 6h-11V8a6 6 0 0 1 6-6h11zm-1.8 1.8H8.5a4.2 4.2 0 0 0-4.195 3.99L4.3 8v10.2h9.2a4.2 4.2 0 0 0 4.195-3.99L17.7 14V3.8zM14 12v2H8v-2h6zm0-4v2H8V8h6z"
  }));
});

/**
* @file 图标work-order
* @author zhanglili
*/
var IconWorkOrder =
/*#__PURE__*/
createIcon('work-order', SVG$2G);

var SVG$2H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M508.7 97.5L128 370.4l385.3 275.3 383.8-274.2-388.4-274zm.2 67.1l293.8 207.2-289.4 206.7L222 370.3l286.9-205.7z"
  }), React.createElement("path", {
    d: "M541.9 403.6l10.3 120.2-59.6-5.1-10.3-120.1-149.5-14.4-5-59.6 149 14.4-10.1-118.1 59.6 5.1 10 118.1 157.1 14 5.1 59.6z"
  }), React.createElement("path", {
    d: "M517.4 856.2L185.1 618.5l-.1-70.8L510.3 780l385.5-278.5 1.3-130.1-56 27.1V469L510.6 713 130.5 440.3V647l385.9 275.5 210.5-140 115-.2-.1-54.7-131.4.2z"
  }));
});

/**
* @file 图标xdb
* @author zhanglili
*/
var IconXDB =
/*#__PURE__*/
createIcon('xdb', SVG$2H);

var SVG$2I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M773.835 835.574c101.697 0 184.138-82.442 184.138-184.138s-82.442-184.138-184.138-184.138-184.138 82.442-184.138 184.138 82.441 184.138 184.138 184.138zm0-61.379c-67.798 0-122.759-54.961-122.759-122.759s54.961-122.759 122.759-122.759 122.759 54.961 122.759 122.759-54.961 122.759-122.759 122.759z"
  }), React.createElement("path", {
    d: "M773.835 712.815c33.899 0 61.379-27.481 61.379-61.379 0-33.899-27.481-61.379-61.379-61.379s-61.379 27.48-61.379 61.379 27.48 61.379 61.379 61.379zM743.145 804.885v153.448h61.38V804.885z"
  }), React.createElement("path", {
    d: "M896.594 896.954H651.656v61.379h244.938zm0-797.933h61.38v368.277h-61.38zm-736.554 0h736.554V160.4H160.04zm-61.379 0h61.379v797.933H98.661zm61.379 736.553h306.898v61.38H160.04zm219.905-154.19l87.545 87.545-43.401 43.402-87.546-87.545-89.85 89.85-43.402-43.402 89.85-89.85-86.062-86.062 43.402-43.402 86.062 86.062 83.757-83.757 43.402 43.402zM221.42 221.78h613.795v61.379H221.42zm0 122.759h429.656v61.379H221.42z"
  }));
});

/**
* @file 图标xray
* @author zhanglili
*/
var IconXray =
/*#__PURE__*/
createIcon('xray', SVG$2I);

export { IconAFS, IconAGILE, IconALB, IconAccountMove, IconAdd, IconAllProduct, IconAllResource, IconAntispam, IconApplication, IconApplicationSolid, IconArrow, IconArrowsDown, IconAsr, IconBCloud, IconBDRP, IconBGW, IconBNS, IconBPFS, IconBaiduAppSVSP, IconBaiduCloud, IconBatch, IconBigSQL, IconBigpipe, IconBrcc, IconBrccProject, IconBugbye, IconBuildCloud, IconCCOS, IconCDN, IconCNAP, IconCOS, IconCOV, IconChaosengineer, IconCheck, IconClose, IconCloudNative, IconCloudProduct, IconCollect, IconCollected, IconConfig, IconCopy, IconCosClient, IconCustomNav, IconDDoS, IconDNS, IconDSTREAM, IconDTS, IconDatabase, IconDatatable, IconDelete, IconDemo, IconDownload, IconEDW, IconEKS, IconENS, IconEPC, IconEci, IconEdit, IconEnv, IconExpend, IconEyeIgnore, IconFailCircleO, IconFailCircleSolid, IconFeedback, IconFilter, IconFinance, IconFrontEnd, IconFrozenAmount, IconFullScreen, IconGTC, IconGaiaDB, IconGrafana, IconGroup, IconGroupCloud, IconHadoop, IconHeadphone, IconHelp, IconHelpLink, IconHint, IconHome, IconICafe, IconICloud, IconICode, IconIP, IconIReport, IconIcloudLogo, IconIncome, IconIndexPage, IconInfoMark, IconIpipe, IconIregistry, IconKongMing, IconLb, IconLeft, IconMPI, IconMailList, IconMapReduce, IconMatrix, IconMenuFoldOutline, IconMenuUnfoldOutline, IconMesh, IconMinALB, IconMobile, IconMolaDB, IconMonitor, IconMonitoring, IconMonitoringThree, IconMore, IconNSC, IconNat, IconNetwork, IconNewEdit, IconNews, IconODP, IconODW, IconOOS, IconOpera, IconOverview, IconOwe, IconPDB, IconPaddleCloud, IconPandora, IconPaper, IconPenWithPaper, IconProduct, IconProductEntries, IconProject, IconProm, IconQianMo, IconQuestionMark, IconRDW, IconRMS, IconROS, IconRPC, IconRefresh, IconRefreshs, IconRemind, IconReply, IconSCI, IconSSM, IconSearch, IconSeer, IconSetUp, IconSmartMonitor, IconSolaria, IconSonar, IconSpark, IconStar, IconStarFill, IconStreamCloud, IconSubProject, IconSuccessCircleO, IconSuccessSolid, IconTTS, IconTableStorage, IconThumbsup, IconThumbsupFill, IconTop, IconTopFill, IconTopPoint, IconUser, IconUserAccount, IconUserGroup, IconVMS, IconVRMC, IconVersion, IconVic, IconWaiting, IconWarn, IconWorkOrder, IconWorkbench, IconXDB, IconXray };
//# sourceMappingURL=index.js.map
